{
  "v": "5.12.1",
  "fr": 30,
  "ip": 0,
  "op": 165,
  "w": 360,
  "h": 800,
  "nm": "Opçao_3",
  "ddd": 0,
  "assets": [
    {
      "id": "comp_0",
      "nm": "mosquetão verde",
      "fr": 30,
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "Camada 2 contornos",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [227.358, 342.041, 0], "ix": 2, "l": 2 },
            "a": { "a": 0, "k": [6.569, 6.818, 0], "ix": 1, "l": 2 },
            "s": { "a": 0, "k": [248, 248, 100], "ix": 6, "l": 2 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.071, -0.478],
                        [0.432, 0.304],
                        [-0.041, 0.158]
                      ],
                      "o": [
                        [-0.054, 0.362],
                        [-0.099, -0.069],
                        [0.278, 0.062]
                      ],
                      "v": [
                        [2.748, -4.89],
                        [1.374, -4.637],
                        [1.331, -5.13]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.254, -0.242],
                        [0.047, 0.201],
                        [-0.167, -0.02]
                      ],
                      "o": [
                        [-0.186, -0.088],
                        [-0.038, -0.162],
                        [0.398, 0.104]
                      ],
                      "v": [
                        [2.678, -3.331],
                        [2.133, -3.699],
                        [2.482, -4.263]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.578, 0.3],
                        [-0.071, -0.054],
                        [-0.019, -0.13],
                        [0.263, -0.1],
                        [0.034, 0.195],
                        [0, 0],
                        [0.038, -0.137],
                        [-0.019, -0.158],
                        [0.149, 0.06],
                        [0.091, 0.428]
                      ],
                      "o": [
                        [0.127, -0.066],
                        [0.115, 0.088],
                        [0.034, 0.23],
                        [-0.108, 0.041],
                        [0, 0],
                        [-0.186, -0.021],
                        [-0.022, 0.075],
                        [-0.139, 0.225],
                        [-0.426, -0.172],
                        [0.707, -0.282]
                      ],
                      "v": [
                        [3.35, -3.065],
                        [3.684, -2.965],
                        [3.707, -2.589],
                        [3.604, -2.092],
                        [3.203, -2.201],
                        [3.083, -2.898],
                        [2.802, -2.551],
                        [2.898, -2.241],
                        [2.484, -2.006],
                        [2.219, -2.92]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 3",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 3,
                  "ty": "sh",
                  "ix": 4,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.317, 0.158],
                        [-0.058, -0.193],
                        [0.193, -0.065],
                        [0.087, 0.072]
                      ],
                      "o": [
                        [0.189, -0.094],
                        [0.041, 0.135],
                        [-0.115, 0.039],
                        [0.199, -0.367]
                      ],
                      "v": [
                        [3.285, -4.239],
                        [3.744, -3.941],
                        [3.572, -3.445],
                        [3.105, -3.371]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 4,
                  "ty": "sh",
                  "ix": 5,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.148, 0.111],
                        [-0.116, -0.176],
                        [-0.038, -0.212],
                        [0.575, 0.381]
                      ],
                      "o": [
                        [0.186, -0.139],
                        [0.049, 0.074],
                        [-0.61, -0.193],
                        [-0.084, -0.056]
                      ],
                      "v": [
                        [3.198, -5.132],
                        [4.497, -5.01],
                        [4.516, -4.595],
                        [3.165, -4.719]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 5",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 5,
                  "ty": "sh",
                  "ix": 6,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.268, 0.013],
                        [0.086, 0.213],
                        [-0.13, -0.008],
                        [-0.071, -0.208]
                      ],
                      "o": [
                        [-0.254, -0.013],
                        [-0.067, -0.167],
                        [0.204, 0.012],
                        [0.063, 0.182]
                      ],
                      "v": [
                        [4.401, -3.454],
                        [3.974, -3.983],
                        [4.308, -4.292],
                        [4.611, -3.967]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 6,
                  "ty": "sh",
                  "ix": 7,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.285, -0.166],
                        [0.118, 0.156],
                        [-0.097, 0.198],
                        [-0.181, -0.086]
                      ],
                      "o": [
                        [-0.129, 0.076],
                        [0.035, -0.282],
                        [0.107, -0.216],
                        [0.18, 0.087]
                      ],
                      "v": [
                        [4.489, -2.112],
                        [4.032, -2.201],
                        [4.093, -2.878],
                        [4.556, -3.059]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 7",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 7,
                  "ty": "sh",
                  "ix": 8,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.112, -0.114],
                        [0.173, 0.107],
                        [0.012, 0.294],
                        [-0.092, -0.246]
                      ],
                      "o": [
                        [-0.1, 0.1],
                        [-0.043, -0.277],
                        [0.267, 0.013],
                        [0.065, 0.175]
                      ],
                      "v": [
                        [4.643, -0.954],
                        [4.208, -0.951],
                        [4.097, -1.755],
                        [4.721, -1.406]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 8",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 8,
                  "ty": "sh",
                  "ix": 9,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.04, -0.202],
                        [0.202, 0.04],
                        [0.18, 0.105],
                        [-0.256, 0.215],
                        [-0.062, -0.102],
                        [-0.005, -0.262],
                        [-0.036, 0.256],
                        [-0.006, -0.322]
                      ],
                      "o": [
                        [-0.059, 0.303],
                        [-0.157, -0.031],
                        [-0.134, -0.212],
                        [0.213, -0.179],
                        [0.083, 0.135],
                        [0.335, -0.093],
                        [0.036, -0.257],
                        [0.003, 0.191]
                      ],
                      "v": [
                        [4.7, 0.256],
                        [3.922, 0.368],
                        [3.393, 0.495],
                        [3.293, -0.497],
                        [3.789, -0.334],
                        [3.824, 0.226],
                        [4.128, -0.393],
                        [4.829, -0.479]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 9",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 9,
                  "ty": "sh",
                  "ix": 10,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.113, -0.205],
                        [0.276, 0.065],
                        [0, 0],
                        [-0.194, 0.158],
                        [-0.069, -0.211]
                      ],
                      "o": [
                        [-0.102, 0.186],
                        [0, 0],
                        [0.03, -0.218],
                        [0.115, -0.093],
                        [0.087, 0.265]
                      ],
                      "v": [
                        [4.745, 2.72],
                        [4.147, 2.959],
                        [4.208, 2.519],
                        [4.344, 1.957],
                        [4.819, 2.017]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 10",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 10,
                  "ty": "sh",
                  "ix": 11,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.243, -0.126],
                        [0.04, 0.16],
                        [-0.219, 0.076],
                        [-0.011, -0.168]
                      ],
                      "o": [
                        [-0.19, 0.098],
                        [-0.039, -0.155],
                        [0.224, -0.078],
                        [0.01, 0.148]
                      ],
                      "v": [
                        [4.733, 4.084],
                        [4.267, 3.779],
                        [4.458, 3.266],
                        [4.823, 3.58]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 11",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 11,
                  "ty": "sh",
                  "ix": 12,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.268, -0.098],
                        [0.092, 0.14],
                        [-0.223, -0.13],
                        [-0.056, -0.191]
                      ],
                      "o": [
                        [0.021, -0.228],
                        [0.328, 0.032],
                        [0.13, 0.076],
                        [-0.301, -0.017]
                      ],
                      "v": [
                        [4.28, 5.057],
                        [4.163, 4.566],
                        [4.87, 4.516],
                        [4.999, 5.04]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 12",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 12,
                  "ty": "sh",
                  "ix": 13,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.095, 0.23],
                        [-0.108, -0.109],
                        [-0.037, -0.212],
                        [0.252, 0.07]
                      ],
                      "o": [
                        [0.148, -0.036],
                        [0.184, 0.186],
                        [-0.257, -0.008],
                        [0.096, -0.276]
                      ],
                      "v": [
                        [4.14, 0.857],
                        [4.657, 0.802],
                        [4.771, 1.506],
                        [4.118, 1.53]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 13",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 13,
                  "ty": "sh",
                  "ix": 14,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.276, -0.067],
                        [0.074, 0.05],
                        [-0.136, 0.195],
                        [-0.178, -0.091]
                      ],
                      "o": [
                        [-0.103, 0.025],
                        [-0.27, -0.186],
                        [0.139, -0.2],
                        [0.184, 0.093]
                      ],
                      "v": [
                        [3.809, 4.118],
                        [3.395, 4.175],
                        [3.378, 3.487],
                        [3.774, 3.3]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 14",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 14,
                  "ty": "sh",
                  "ix": 15,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.115, -0.098],
                        [0, 0],
                        [-0.244, -0.021],
                        [-0.202, -0.303]
                      ],
                      "o": [
                        [0, 0],
                        [-0.178, -0.1],
                        [0.898, 0.08],
                        [0.059, 0.088]
                      ],
                      "v": [
                        [3.879, 4.984],
                        [2.576, 5.102],
                        [2.654, 4.459],
                        [3.837, 4.555]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 15",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 15,
                  "ty": "sh",
                  "ix": 16,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.101, -0.276],
                        [0.201, -0.074],
                        [0.007, 0.213],
                        [-0.271, -0.033],
                        [-0.217, -0.162],
                        [0.172, -0.151],
                        [-0.028, 0.364]
                      ],
                      "o": [
                        [-0.217, -0.028],
                        [-0.062, -0.366],
                        [0.268, -0.226],
                        [0.15, 0.019],
                        [0.154, 0.114],
                        [-0.271, 0.239],
                        [-0.322, 0.055]
                      ],
                      "v": [
                        [2.136, 4.171],
                        [1.584, 4.288],
                        [1.474, 3.518],
                        [2.23, 3.484],
                        [2.835, 3.344],
                        [2.996, 4.096],
                        [2.358, 3.561]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 16",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 16,
                  "ty": "sh",
                  "ix": 17,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.457, -0.046],
                        [-0.062, 0.079],
                        [-1.41, 0.202],
                        [-0.013, -0.253]
                      ],
                      "o": [
                        [-0.179, 0.018],
                        [0.49, -0.627],
                        [0.246, -0.036],
                        [-0.453, -0.075]
                      ],
                      "v": [
                        [0.803, 5.181],
                        [0.574, 4.894],
                        [1.845, 4.466],
                        [2.119, 5.062]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 17",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 17,
                  "ty": "sh",
                  "ix": 18,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.106, 0.174],
                        [-0.178, -0.013],
                        [-0.146, -0.189],
                        [0.278, -0.107]
                      ],
                      "o": [
                        [0.032, -0.219],
                        [0.427, 0.032],
                        [-0.256, -0.097],
                        [0.022, -0.284]
                      ],
                      "v": [
                        [0.495, 3.643],
                        [0.931, 3.353],
                        [1.203, 4.216],
                        [0.513, 4.217]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 18",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 18,
                  "ty": "sh",
                  "ix": 19,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.217, 0.174],
                        [0.206, 0.245],
                        [0.25, -0.159],
                        [0.117, 0.083],
                        [-0.333, 0.086],
                        [-0.029, -0.188],
                        [-0.036, 0.087],
                        [-0.309, -0.047],
                        [-0.095, -0.294],
                        [0.003, 0.306],
                        [-0.238, -0.007],
                        [0.109, -0.268],
                        [0.206, -0.01]
                      ],
                      "o": [
                        [-0.142, -0.115],
                        [-0.219, 0.276],
                        [-0.131, 0.084],
                        [0.024, 0.017],
                        [0.126, -0.032],
                        [-0.027, 0.188],
                        [0.144, -0.342],
                        [0.026, 0.28],
                        [0.329, -0.232],
                        [0.2, -0.082],
                        [0.045, 0.301],
                        [-0.113, 0.275],
                        [-0.238, 0.012]
                      ],
                      "v": [
                        [-0.269, 2.912],
                        [-0.478, 2.376],
                        [-0.938, 3.099],
                        [-1.336, 3.06],
                        [-1.112, 2.146],
                        [-0.667, 2.149],
                        [-0.547, 2.371],
                        [0.121, 2.096],
                        [0.261, 2.953],
                        [0.491, 2.138],
                        [1.119, 1.991],
                        [1.121, 2.928],
                        [0.34, 3.027]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 19",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 19,
                  "ty": "sh",
                  "ix": 20,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.016, -0.239],
                        [0.31, -0.083],
                        [-0.059, 0.214],
                        [-0.089, 0.007],
                        [-0.185, 0.34],
                        [-0.24, -0.002],
                        [-0.023, -0.218],
                        [0.12, -0.126],
                        [0.172, 0.026],
                        [0.116, 0.079]
                      ],
                      "o": [
                        [-0.265, -0.103],
                        [-0.004, -0.286],
                        [0.039, -0.141],
                        [0.349, -0.026],
                        [0.117, -0.214],
                        [0.114, 0.001],
                        [0.022, 0.197],
                        [-0.102, 0.106],
                        [-0.06, -0.139],
                        [-0.176, 0.144]
                      ],
                      "v": [
                        [-0.479, 4.37],
                        [-1.215, 4.318],
                        [-1.251, 3.621],
                        [-0.959, 3.397],
                        [-0.464, 3.844],
                        [-0.142, 3.451],
                        [0.238, 3.557],
                        [0.17, 4.095],
                        [-0.318, 4.207],
                        [-0.462, 3.881]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 20",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 20,
                  "ty": "sh",
                  "ix": 21,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.066, -0.123],
                        [0.519, -0.106],
                        [0, 0],
                        [-0.111, -0.064]
                      ],
                      "o": [
                        [-0.202, 0.372],
                        [0, 0],
                        [0.086, -0.177],
                        [0.18, 0.103]
                      ],
                      "v": [
                        [0.217, 5.015],
                        [-1.19, 5.156],
                        [-1.269, 4.722],
                        [0.207, 4.593]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 21",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 21,
                  "ty": "sh",
                  "ix": 22,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.316, 0.089],
                        [-0.229, 0.075],
                        [-0.221, -0.009],
                        [-0.12, 0.025],
                        [-0.136, -0.029],
                        [0, 0],
                        [0.104, -0.013],
                        [0.153, 0.024]
                      ],
                      "o": [
                        [-0.334, -0.094],
                        [0.273, -0.09],
                        [0.19, 0.008],
                        [0.09, -0.019],
                        [0, 0],
                        [0.048, 0.156],
                        [-0.427, 0.055],
                        [-0.282, -0.045]
                      ],
                      "v": [
                        [-2.007, 1.819],
                        [-2.13, 0.957],
                        [-1.541, 1.275],
                        [-1.259, 0.9],
                        [-0.856, 0.903],
                        [-0.65, 1.576],
                        [-0.975, 1.765],
                        [-1.445, 1.267]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 22",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 22,
                  "ty": "sh",
                  "ix": 23,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.576, 0.236],
                        [0.498, 0.101],
                        [-0.034, 0.116],
                        [-0.341, -0.532],
                        [-0.129, 0.044],
                        [-0.435, 0.009],
                        [-0.023, -0.225]
                      ],
                      "o": [
                        [-0.408, 0.236],
                        [-0.098, -0.021],
                        [0.44, -0.347],
                        [0.212, -0.137],
                        [0.427, -0.144],
                        [0.056, 0.158],
                        [-0.554, 0.087]
                      ],
                      "v": [
                        [-3.211, 5.095],
                        [-4.641, 5.274],
                        [-4.789, 4.867],
                        [-3.318, 5.104],
                        [-2.986, 4.708],
                        [-1.69, 4.636],
                        [-1.542, 5.113]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 23",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 23,
                  "ty": "sh",
                  "ix": 24,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.181, 0.044],
                        [-0.005, -0.272],
                        [0.111, 0.039],
                        [0.008, 0.262]
                      ],
                      "o": [
                        [0.128, 0.268],
                        [-0.114, 0.019],
                        [-0.22, -0.25],
                        [0.138, -0.052]
                      ],
                      "v": [
                        [-4.455, 3.468],
                        [-4.298, 4.287],
                        [-4.665, 4.416],
                        [-4.87, 3.631]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 24",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 24,
                  "ty": "sh",
                  "ix": 25,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.276, 0.016],
                        [-0.094, -0.281],
                        [-0.322, 0.022],
                        [0.619, -0.54],
                        [-0.072, -0.559],
                        [-0.15, -0.211],
                        [0.178, 0.022],
                        [0.08, 0.172],
                        [0.385, -0.126],
                        [-0.041, 0.124],
                        [-0.082, 0.119],
                        [0.003, 0.102],
                        [0.21, 1.142],
                        [-0.04, -0.259],
                        [0.107, 0.1],
                        [0.012, 0.168]
                      ],
                      "o": [
                        [0.21, -0.012],
                        [0.232, -0.297],
                        [-0.235, 0.697],
                        [0.138, 0.691],
                        [0.024, 0.187],
                        [-0.216, 0.071],
                        [-0.151, -0.197],
                        [-0.225, -0.492],
                        [-0.092, 0.03],
                        [0.075, -0.229],
                        [0.051, -0.076],
                        [-0.006, -0.26],
                        [-0.297, 0.047],
                        [-0.105, 0.074],
                        [-0.157, -0.147],
                        [-0.021, -0.283]
                      ],
                      "v": [
                        [-4.677, 2.167],
                        [-4.33, 2.457],
                        [-3.455, 2.048],
                        [-3.646, 3.3],
                        [-2.491, 3.635],
                        [-2.446, 4.234],
                        [-2.996, 4.323],
                        [-3.109, 3.717],
                        [-3.748, 4.361],
                        [-4.056, 4.157],
                        [-3.936, 3.61],
                        [-3.674, 3.426],
                        [-4.138, 2.469],
                        [-4.359, 3.089],
                        [-4.837, 3.184],
                        [-4.916, 2.593]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 25",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 25,
                  "ty": "sh",
                  "ix": 26,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.24, -0.064],
                        [-0.267, 0.274],
                        [-0.265, -0.073],
                        [0.022, -0.203],
                        [0.11, -0.063],
                        [0.217, -0.072],
                        [0.096, -0.021],
                        [0.026, 0.198]
                      ],
                      "o": [
                        [0.396, 0.105],
                        [0.082, -0.086],
                        [0.188, 0.052],
                        [-0.013, 0.126],
                        [-0.426, 0.242],
                        [-0.099, 0.033],
                        [-0.236, 0.052],
                        [-0.022, -0.167]
                      ],
                      "v": [
                        [-4.66, 1.048],
                        [-4.183, 1.569],
                        [-3.806, 1.015],
                        [-3.523, 1.361],
                        [-3.563, 1.703],
                        [-4.264, 1.647],
                        [-4.503, 1.929],
                        [-4.946, 1.544]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 26",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 26,
                  "ty": "sh",
                  "ix": 27,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.338, 0.011],
                        [-0.211, 0.182],
                        [-0.126, -0.043],
                        [-0.084, -0.098],
                        [-0.337, -0.125],
                        [-0.04, -0.201],
                        [0.324, 0.046],
                        [0.293, -0.068],
                        [0.156, 0.035],
                        [0.52, -0.252],
                        [0.058, 0.064]
                      ],
                      "o": [
                        [0.206, -0.007],
                        [0.147, -0.126],
                        [0.183, 0.062],
                        [0.267, 0.316],
                        [0.145, 0.054],
                        [0.049, 0.243],
                        [-0.318, -0.045],
                        [-0.409, 0.095],
                        [-0.339, -0.077],
                        [-0.089, 0.043],
                        [0.044, 0.048]
                      ],
                      "v": [
                        [-4.724, -0.347],
                        [-4.089, -0.332],
                        [-3.667, -0.331],
                        [-3.52, 0.064],
                        [-2.864, -0.401],
                        [-2.592, -0.086],
                        [-2.965, 0.6],
                        [-3.789, 0.694],
                        [-4.272, -0.206],
                        [-4.668, 0.71],
                        [-4.975, 0.606]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 27",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 27,
                  "ty": "sh",
                  "ix": 28,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.233, 0.168],
                        [-0.077, -0.107],
                        [0.028, -0.136],
                        [0.048, 0.248]
                      ],
                      "o": [
                        [0.122, -0.089],
                        [0.089, 0.122],
                        [-0.229, -0.142],
                        [-0.03, -0.155]
                      ],
                      "v": [
                        [-4.922, -1.549],
                        [-4.513, -1.367],
                        [-4.461, -0.536],
                        [-5.005, -0.959]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 28",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 28,
                  "ty": "sh",
                  "ix": 29,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.176, -0.502],
                        [0.083, 0.226],
                        [0.037, 0.053],
                        [0.036, -0.002],
                        [0.015, -0.015],
                        [0.007, 0.003],
                        [0.255, 0.055],
                        [0.061, 0.072],
                        [0.012, 0.17],
                        [-0.117, 0.049],
                        [-0.133, -0.055],
                        [-0.022, 0.001],
                        [-0.263, -0.15]
                      ],
                      "o": [
                        [-0.24, -0.038],
                        [-0.039, -0.108],
                        [-0.054, -0.076],
                        [-0.013, 0.015],
                        [-0.008, -0.002],
                        [-0.113, 0.139],
                        [-0.08, -0.017],
                        [-0.002, -0.188],
                        [-0.013, -0.186],
                        [0.153, -0.065],
                        [0.018, -0.022],
                        [0.164, -0.183],
                        [0.448, 0.254]
                      ],
                      "v": [
                        [-2.598, -0.65],
                        [-3.229, -0.955],
                        [-3.238, -1.218],
                        [-3.368, -1.311],
                        [-3.406, -1.265],
                        [-3.428, -1.279],
                        [-3.848, -0.716],
                        [-4.151, -0.754],
                        [-4.176, -1.278],
                        [-3.803, -1.515],
                        [-3.428, -1.279],
                        [-3.368, -1.311],
                        [-2.871, -1.569]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 29",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 29,
                  "ty": "sh",
                  "ix": 30,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-0.186, -0.1],
                        [-0.118, 0.093],
                        [-0.125, -0.141],
                        [-0.113, -0.264],
                        [-0.037, 0.205],
                        [-0.223, -0.06],
                        [-0.23, -0.027],
                        [-0.192, -0.213],
                        [-0.005, 0.003],
                        [-0.269, 0.073],
                        [0.015, -0.066],
                        [0, 0],
                        [0.173, -0.094],
                        [0.081, 0.12],
                        [0.044, 0.04],
                        [0.037, -0.022],
                        [0.005, -0.004],
                        [0.003, 0.003],
                        [0.004, -0.007],
                        [0, 0],
                        [0.07, 0.025],
                        [0.131, 0.524],
                        [0.048, -0.225],
                        [0.089, 0.106],
                        [0.019, 0.031],
                        [0.03, -0.054],
                        [0.05, -0.062],
                        [0.135, 0.076],
                        [0.09, 0.142],
                        [0.249, -0.018],
                        [0.141, 0.089]
                      ],
                      "o": [
                        [0.106, 0.158],
                        [0.105, -0.179],
                        [0.077, -0.062],
                        [0.187, 0.211],
                        [0.371, -0.082],
                        [0.056, -0.313],
                        [0.236, 0.064],
                        [0.085, 0.224],
                        [0.004, -0.004],
                        [0.233, -0.281],
                        [0.121, -0.033],
                        [0, 0],
                        [-0.036, 0.159],
                        [-0.112, 0.061],
                        [-0.06, -0.088],
                        [-0.045, -0.041],
                        [-0.004, 0.005],
                        [-0.002, -0.002],
                        [-0.004, 0.005],
                        [0, 0],
                        [-0.057, 0.107],
                        [-0.473, -0.17],
                        [-0.353, -0.024],
                        [-0.041, 0.19],
                        [-0.05, -0.096],
                        [-0.031, -0.051],
                        [-0.037, 0.064],
                        [-0.163, 0.204],
                        [-0.167, -0.094],
                        [-0.222, -0.351],
                        [-0.373, 0.028],
                        [0, 0]
                      ],
                      "v": [
                        [-4.576, -2.898],
                        [-4.376, -2.488],
                        [-4.091, -2.9],
                        [-3.718, -2.886],
                        [-3.511, -2.126],
                        [-3.294, -2.717],
                        [-2.556, -2.861],
                        [-1.906, -2.967],
                        [-1.677, -2.263],
                        [-1.661, -2.27],
                        [-1.126, -3.003],
                        [-0.807, -2.812],
                        [-0.865, -2.556],
                        [-1.017, -1.963],
                        [-1.461, -1.988],
                        [-1.527, -2.241],
                        [-1.661, -2.27],
                        [-1.672, -2.255],
                        [-1.677, -2.263],
                        [-1.692, -2.255],
                        [-1.795, -2.062],
                        [-1.977, -1.885],
                        [-2.393, -2.702],
                        [-2.69, -2.057],
                        [-3.246, -1.858],
                        [-3.282, -2.06],
                        [-3.423, -2.105],
                        [-3.547, -1.914],
                        [-4.055, -1.952],
                        [-4.255, -2.411],
                        [-4.824, -1.855],
                        [-5.078, -2.743]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 30",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 30,
                  "ty": "sh",
                  "ix": 31,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.184, -0.032],
                        [-0.039, -0.286],
                        [0, 0],
                        [0.051, 0.273]
                      ],
                      "o": [
                        [0.082, 0.292],
                        [0, 0],
                        [-0.105, -0.275],
                        [0.154, -0.105]
                      ],
                      "v": [
                        [-4.667, -4.042],
                        [-4.487, -3.245],
                        [-4.983, -3.162],
                        [-5.175, -3.911]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 31",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 31,
                  "ty": "sh",
                  "ix": 32,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.174, 0.216],
                        [-0.17, -0.109],
                        [0.041, -0.009],
                        [0.065, 0.063]
                      ],
                      "o": [
                        [0.142, -0.175],
                        [0.234, 0.148],
                        [-0.088, 0.018],
                        [-0.256, -0.248]
                      ],
                      "v": [
                        [-4.093, -3.883],
                        [-3.73, -4.02],
                        [-3.762, -3.287],
                        [-4.073, -3.187]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 32",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 32,
                  "ty": "sh",
                  "ix": 33,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.103, -0.054],
                        [0.071, 0.077],
                        [-0.099, 0.16],
                        [-0.102, -0.057]
                      ],
                      "o": [
                        [-0.085, 0.045],
                        [-0.132, -0.142],
                        [0.122, -0.133],
                        [0.187, 0.106]
                      ],
                      "v": [
                        [-2.743, -3.287],
                        [-3.139, -3.292],
                        [-3.316, -3.987],
                        [-2.812, -4.086]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 33",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 33,
                  "ty": "sh",
                  "ix": 34,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.027, 0.101],
                        [-0.381, -0.025],
                        [-0.076, -0.203],
                        [0.188, -0.017],
                        [0.12, 0.218]
                      ],
                      "o": [
                        [0.289, -0.265],
                        [0.12, 0.008],
                        [0.056, 0.15],
                        [-0.546, 0.047],
                        [-0.042, -0.077]
                      ],
                      "v": [
                        [-4.24, -4.783],
                        [-3.186, -4.979],
                        [-2.733, -4.86],
                        [-3.038, -4.369],
                        [-4.196, -4.422]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 34",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 34,
                  "ty": "sh",
                  "ix": 35,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.283, -0.062],
                        [-0.008, 0.251],
                        [-0.059, 0.111],
                        [-0.074, -0.162],
                        [-0.001, -0.003],
                        [0.001, 0.002]
                      ],
                      "o": [
                        [-0.115, 0.026],
                        [0.008, -0.223],
                        [0.064, -0.121],
                        [0.001, 0.002],
                        [-0.001, -0.003],
                        [0.006, 0.068]
                      ],
                      "v": [
                        [-1.979, -3.325],
                        [-2.377, -3.409],
                        [-2.358, -3.882],
                        [-1.814, -4.008],
                        [-1.808, -4.004],
                        [-1.814, -4.008]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 35",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 35,
                  "ty": "sh",
                  "ix": 36,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.205, -0.276],
                        [0.119, -0.102],
                        [0.175, 0.394]
                      ],
                      "o": [
                        [0.063, 0.085],
                        [-0.174, 0.151],
                        [-0.224, -0.505]
                      ],
                      "v": [
                        [-0.95, -4.915],
                        [-0.917, -4.524],
                        [-2.403, -4.718]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 36",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 36,
                  "ty": "sh",
                  "ix": 37,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.047, 0.205],
                        [-0.126, -0.051],
                        [-0.189, -0.47],
                        [0, 0]
                      ],
                      "o": [
                        [-0.043, -0.189],
                        [0.383, 0.153],
                        [0, 0],
                        [0.116, -0.301]
                      ],
                      "v": [
                        [-1.482, -3.921],
                        [-1.109, -4.166],
                        [-0.778, -3.281],
                        [-1.489, -3.284]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 37",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 37,
                  "ty": "sh",
                  "ix": 38,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.229, -0.136],
                        [0.002, 0.165],
                        [-0.011, 0.175],
                        [-0.057, -0.212]
                      ],
                      "o": [
                        [-0.146, 0.084],
                        [-0.004, -0.189],
                        [0.239, -0.03],
                        [0.045, 0.165]
                      ],
                      "v": [
                        [-0.876, -0.74],
                        [-1.419, -1.052],
                        [-1.375, -1.677],
                        [-0.824, -1.319]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 38",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 38,
                  "ty": "sh",
                  "ix": 39,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.005, 0.232],
                        [-0.25, 0.07],
                        [-0.024, -0.234],
                        [-0.009, -0.211]
                      ],
                      "o": [
                        [0.008, -0.373],
                        [0.149, -0.041],
                        [0.022, 0.218],
                        [-0.266, -0.059]
                      ],
                      "v": [
                        [-2.383, -1.011],
                        [-2.164, -1.541],
                        [-1.715, -1.384],
                        [-1.809, -0.716]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 39",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 39,
                  "ty": "sh",
                  "ix": 40,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.237, 0.039],
                        [-0.2, 0.087],
                        [0.431, 0.12]
                      ],
                      "o": [
                        [0.142, -0.024],
                        [-0.062, 0.268],
                        [-0.334, -0.093]
                      ],
                      "v": [
                        [-3.03, 0.991],
                        [-2.577, 0.905],
                        [-2.904, 1.855]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 40",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 40,
                  "ty": "sh",
                  "ix": 41,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.197, -0.313],
                        [0.132, -0.003],
                        [0.561, 0.216],
                        [0.193, 0.371],
                        [-0.363, 0.008]
                      ],
                      "o": [
                        [-0.127, 0.08],
                        [-0.12, -0.885],
                        [-0.415, -0.159],
                        [0.381, 0.202],
                        [0.435, -0.009]
                      ],
                      "v": [
                        [-1.702, 3.007],
                        [-2.192, 3.06],
                        [-3.062, 3.179],
                        [-3.164, 2.079],
                        [-2.092, 2.092]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 41",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 41,
                  "ty": "sh",
                  "ix": 42,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.072, -0.225],
                        [0.141, 0.025],
                        [-0.134, 0.187],
                        [-0.079, 0.004],
                        [0.016, -0.112]
                      ],
                      "o": [
                        [-0.16, 0.01],
                        [-0.187, -0.215],
                        [0.08, -0.11],
                        [0.084, -0.003],
                        [-0.033, 0.228]
                      ],
                      "v": [
                        [-1.573, 4.192],
                        [-2.074, 4.3],
                        [-2.11, 3.603],
                        [-1.843, 3.415],
                        [-1.547, 3.584]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 42",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 42,
                  "ty": "sh",
                  "ix": 43,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.268, -0.172],
                        [0.042, -0.34],
                        [0.228, -0.072],
                        [0.062, 0.193],
                        [0.131, 0.247],
                        [0.072, -0.185],
                        [0.216, 0.045],
                        [0.112, 0.217],
                        [0.016, 0.195],
                        [-0.131, -0.102],
                        [-0.057, -0.098],
                        [-0.03, 0.087],
                        [-0.279, 0.234],
                        [-0.163, 0.036]
                      ],
                      "o": [
                        [0.277, 0.176],
                        [-0.02, 0.171],
                        [-0.132, 0.041],
                        [-0.062, -0.196],
                        [-0.31, 0.088],
                        [-0.115, 0.293],
                        [-0.168, -0.034],
                        [-0.112, -0.216],
                        [-0.021, -0.266],
                        [0.308, 0.24],
                        [0.038, 0.064],
                        [0.254, -0.719],
                        [0.176, -0.148],
                        [0.272, -0.059]
                      ],
                      "v": [
                        [-0.07, -0.463],
                        [0.126, 0.142],
                        [0.024, 0.551],
                        [-0.399, 0.459],
                        [-0.557, -0.193],
                        [-0.827, 0.407],
                        [-1.519, 0.458],
                        [-2.156, 0.523],
                        [-2.294, -0.207],
                        [-1.889, -0.377],
                        [-1.704, 0.288],
                        [-1.487, 0.356],
                        [-1.205, -0.372],
                        [-0.679, -0.306]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 43",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 43,
                  "ty": "sh",
                  "ix": 44,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.108, -0.126],
                        [0.13, 0.077],
                        [0.019, 0.199],
                        [-0.128, 0]
                      ],
                      "o": [
                        [-0.132, 0.156],
                        [-0.109, -0.064],
                        [-0.017, -0.176],
                        [0.378, 0]
                      ],
                      "v": [
                        [0.086, -0.883],
                        [-0.306, -0.831],
                        [-0.48, -1.2],
                        [-0.245, -1.636]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 44",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 44,
                  "ty": "sh",
                  "ix": 45,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, -0.159],
                        [0.315, -0.083],
                        [0.034, 0.132],
                        [0.011, -0.008],
                        [-0.213, -0.144]
                      ],
                      "o": [
                        [0, 0.277],
                        [-0.117, 0.031],
                        [0.015, 0.058],
                        [-0.058, 0.04],
                        [0.128, 0.087]
                      ],
                      "v": [
                        [0.221, 1.257],
                        [-0.151, 1.749],
                        [-0.45, 1.528],
                        [-0.393, 0.953],
                        [0.18, 0.91]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 45",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 45,
                  "ty": "sh",
                  "ix": 46,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0.001],
                        [-0.148, -0.089],
                        [-0.227, -0.33],
                        [-0.32, 0.154],
                        [-0.057, -0.065],
                        [0.319, -0.282],
                        [0.324, 0.009],
                        [0.024, 0.098],
                        [0, -0.001]
                      ],
                      "o": [
                        [0.016, -0.046],
                        [0.249, 0.149],
                        [0.428, 0.003],
                        [0.054, -0.025],
                        [0.28, 0.319],
                        [-0.316, -0.176],
                        [-0.278, -0.008],
                        [0, 0.001],
                        [0, -0.001]
                      ],
                      "v": [
                        [-0.642, -2.864],
                        [-0.077, -2.996],
                        [0.193, -2.241],
                        [0.585, -3.054],
                        [0.842, -2.984],
                        [0.725, -1.969],
                        [-0.227, -2],
                        [-0.642, -2.864],
                        [-0.647, -2.86]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 46",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 46,
                  "ty": "sh",
                  "ix": 47,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.055, 0.219],
                        [-0.108, -0.041],
                        [0.126, -0.211],
                        [0.156, 0.145]
                      ],
                      "o": [
                        [0.06, -0.109],
                        [0.317, 0.121],
                        [-0.082, 0.138],
                        [0.008, -0.138]
                      ],
                      "v": [
                        [-0.556, -4.006],
                        [-0.089, -4.15],
                        [-0.033, -3.483],
                        [-0.586, -3.406]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 47",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 47,
                  "ty": "sh",
                  "ix": 48,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.274, 0.399],
                        [-0.239, -0.046],
                        [0.024, -0.435],
                        [0.103, -0.025]
                      ],
                      "o": [
                        [0.094, -0.137],
                        [0.178, 0.035],
                        [-0.004, 0.074],
                        [-0.814, 0.194]
                      ],
                      "v": [
                        [-0.58, -4.988],
                        [-0.185, -5.095],
                        [1.006, -4.844],
                        [0.847, -4.543]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 48",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 48,
                  "ty": "sh",
                  "ix": 49,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.382, -0.085],
                        [-0.057, 0.053],
                        [-0.12, -0.07]
                      ],
                      "o": [
                        [-0.521, 0.118],
                        [0.16, -0.144],
                        [0.14, 0.082]
                      ],
                      "v": [
                        [1.784, -1.957],
                        [1.308, -2.966],
                        [1.702, -3.043]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 49",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 49,
                  "ty": "sh",
                  "ix": 50,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.277, -0.031],
                        [-0.156, 0.212],
                        [-0.129, -0.077],
                        [-0.174, -0.309]
                      ],
                      "o": [
                        [-0.101, -0.276],
                        [0.107, -0.146],
                        [-0.028, 0.325],
                        [-0.262, -0.003]
                      ],
                      "v": [
                        [2.458, 1.666],
                        [2.376, 0.903],
                        [2.926, 0.845],
                        [3.129, 1.688]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 50",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 50,
                  "ty": "sh",
                  "ix": 51,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.167, 0.179],
                        [-0.204, -0.071],
                        [0.014, -0.219],
                        [0.1, 0.055]
                      ],
                      "o": [
                        [0.106, -0.114],
                        [-0.12, 0.217],
                        [-0.074, 0.082],
                        [-0.231, -0.129]
                      ],
                      "v": [
                        [1.492, 0.995],
                        [2.046, 0.875],
                        [1.993, 1.542],
                        [1.532, 1.654]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 51",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 51,
                  "ty": "sh",
                  "ix": 52,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.085, 0.112],
                        [-0.091, -0.028],
                        [0.137, -0.119],
                        [0.125, 0.041]
                      ],
                      "o": [
                        [0.117, -0.153],
                        [0.293, 0.091],
                        [-0.129, 0.111],
                        [-0.156, -0.051]
                      ],
                      "v": [
                        [0.449, -1.509],
                        [0.744, -1.618],
                        [0.962, -0.929],
                        [0.575, -0.86]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 52",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 52,
                  "ty": "sh",
                  "ix": 53,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.059, -0.154],
                        [0.143, -0.029],
                        [-0.137, 0.176],
                        [-0.061, -0.121]
                      ],
                      "o": [
                        [-0.099, 0.081],
                        [-0.104, -0.22],
                        [0.13, -0.115],
                        [0.051, 0.1]
                      ],
                      "v": [
                        [1.09, 1.563],
                        [0.647, 1.672],
                        [0.521, 0.919],
                        [1.054, 1.139]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 53",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 53,
                  "ty": "sh",
                  "ix": 54,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.314, -0.049],
                        [-0.223, 0.235],
                        [-0.148, -0.075],
                        [-0.181, -0.004],
                        [0.066, -0.339],
                        [0.027, 0.247],
                        [-0.15, -0.136],
                        [0.318, -0.23],
                        [0.322, 0.374],
                        [0.399, -0.163]
                      ],
                      "o": [
                        [-0.359, 0.056],
                        [0.087, -0.092],
                        [0.22, 0.112],
                        [0.372, 0.008],
                        [0.306, -0.032],
                        [-0.024, -0.207],
                        [0.309, 0.281],
                        [-0.559, -0.518],
                        [-0.102, -0.118],
                        [0.062, 0.342]
                      ],
                      "v": [
                        [0.729, 0.606],
                        [0.613, -0.413],
                        [1.101, -0.457],
                        [1.644, -0.477],
                        [2.011, 0.315],
                        [2.299, -0.266],
                        [2.817, -0.485],
                        [2.54, 0.576],
                        [1.467, 0.447],
                        [1.083, -0.214]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 54",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 54,
                  "ty": "sh",
                  "ix": 55,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.045, 0.088],
                        [-0.084, 0.008],
                        [-0.119, -0.015],
                        [0.001, -0.133],
                        [0.21, -0.04]
                      ],
                      "o": [
                        [0.031, 0.061],
                        [0.094, -0.009],
                        [0.19, 0.022],
                        [-0.003, 0.187],
                        [-0.12, 0.024]
                      ],
                      "v": [
                        [3.228, 1.522],
                        [3.397, 0.895],
                        [3.69, 0.778],
                        [3.863, 1.22],
                        [3.552, 1.657]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 55",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 55,
                  "ty": "sh",
                  "ix": 56,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.138, -0.229],
                        [-0.058, -0.287],
                        [0.11, 0.192],
                        [0.083, 0.192],
                        [-0.006, -0.25],
                        [0.114, 0.133],
                        [0.156, -0.075],
                        [0.166, 0.007],
                        [0, 0],
                        [0.023, 0.334],
                        [-0.125, -0.018],
                        [-0.09, -0.056],
                        [-0.031, 0.111],
                        [0, 0],
                        [-0.137, 0.102],
                        [-0.184, 0.02]
                      ],
                      "o": [
                        [0.161, 0.266],
                        [-0.268, 0.031],
                        [-0.069, -0.12],
                        [-0.326, -0.058],
                        [0.004, 0.23],
                        [-0.057, -0.067],
                        [-0.145, 0.069],
                        [0, 0],
                        [0.036, -0.291],
                        [-0.011, -0.157],
                        [0.18, 0.026],
                        [0.087, 0.054],
                        [0, 0],
                        [0.052, -0.185],
                        [0.122, -0.09],
                        [0.185, -0.021]
                      ],
                      "v": [
                        [3.805, 2.024],
                        [3.873, 2.976],
                        [3.325, 2.722],
                        [3.228, 2.116],
                        [2.946, 2.727],
                        [2.386, 2.943],
                        [2.24, 2.698],
                        [1.945, 3.019],
                        [1.557, 3.004],
                        [1.429, 2.115],
                        [1.862, 2.005],
                        [2.103, 2.628],
                        [2.318, 2.572],
                        [2.369, 2.392],
                        [2.64, 1.97],
                        [3.098, 2.034]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 56",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 56,
                  "ty": "sh",
                  "ix": 57,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-0.275, -0.073],
                        [0.052, -0.155],
                        [0.183, -0.02],
                        [0.24, 0.174],
                        [0.016, 0.276],
                        [0.299, 0.089],
                        [-0.002, 0.261],
                        [-0.135, 0.072],
                        [-0.187, 0.078],
                        [-0.067, 0.016],
                        [-0.082, -0.315],
                        [0.016, 0.127]
                      ],
                      "o": [
                        [0.274, 0.026],
                        [-0.203, 0.185],
                        [-0.107, 0.317],
                        [-0.238, 0.025],
                        [-0.197, -0.143],
                        [-0.033, -0.567],
                        [-0.199, -0.06],
                        [0.002, -0.178],
                        [0.212, -0.113],
                        [0.064, -0.026],
                        [0.37, -0.086],
                        [0.073, 0.174],
                        [0, 0]
                      ],
                      "v": [
                        [3.15, -1.753],
                        [3.937, -1.654],
                        [3.787, -1.062],
                        [3.09, -1.01],
                        [2.538, -0.823],
                        [2.237, -1.363],
                        [1.568, -0.823],
                        [1.33, -1.247],
                        [1.467, -1.645],
                        [2.125, -1.5],
                        [2.306, -1.731],
                        [2.926, -1.145],
                        [3.201, -1.333]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 57",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 57,
                  "ty": "sh",
                  "ix": 58,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.417, -0.255],
                        [0.105, -0.006],
                        [0.026, 0.203],
                        [0.07, 0.007],
                        [0.069, -0.091],
                        [0.124, 0.077],
                        [0.043, 0.241],
                        [-0.137, -0.033],
                        [-0.035, -0.153]
                      ],
                      "o": [
                        [0.303, 0.185],
                        [-0.138, 0.007],
                        [-0.018, -0.14],
                        [-0.14, -0.016],
                        [-0.12, 0.157],
                        [-0.125, -0.078],
                        [-0.034, -0.193],
                        [0.199, 0.049],
                        [0.296, 0.298]
                      ],
                      "v": [
                        [1.726, -4.173],
                        [1.738, -3.391],
                        [1.342, -3.413],
                        [1.206, -3.654],
                        [1, -3.43],
                        [0.534, -3.436],
                        [0.35, -3.945],
                        [0.782, -4.166],
                        [1.032, -3.682]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 58",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 58,
                  "ty": "sh",
                  "ix": 59,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.261, 0.005],
                        [0.805, -0.051],
                        [0.075, -0.012],
                        [0.347, -0.317],
                        [0.051, -0.511],
                        [-0.015, -0.673],
                        [0, 0],
                        [0, 0],
                        [0.022, -0.283],
                        [0.219, -0.468],
                        [-0.018, -0.626],
                        [0, 0],
                        [-0.309, 0.008],
                        [0, 0],
                        [-0.089, 0.59],
                        [-0.041, 0.711],
                        [0.023, 0.277],
                        [0, 0],
                        [0, 0],
                        [0.015, 0.441],
                        [0, 0],
                        [0.829, 1.01]
                      ],
                      "o": [
                        [-0.81, -0.015],
                        [-0.111, 0.007],
                        [-0.424, 0.068],
                        [-0.362, 0.329],
                        [-0.064, 0.629],
                        [0, 0],
                        [0, 0],
                        [0.011, 0.273],
                        [-0.034, 0.456],
                        [0.2, 0.609],
                        [0, 0],
                        [0.007, 0.243],
                        [0, 0],
                        [0.664, -0.018],
                        [0.11, -0.727],
                        [0.016, -0.274],
                        [0, 0],
                        [0, 0],
                        [0.002, -0.083],
                        [0, 0],
                        [-0.038, -1.063],
                        [-0.592, -0.722]
                      ],
                      "v": [
                        [0.24, -6.316],
                        [-2.127, -6.189],
                        [-4.214, -6.137],
                        [-5.44, -5.746],
                        [-6.255, -4.376],
                        [-6.24, -1.846],
                        [-6.222, -1.036],
                        [-6.188, -0.221],
                        [-6.171, 0.588],
                        [-6.182, 1.971],
                        [-6.062, 3.817],
                        [-5.927, 6.325],
                        [-2.378, 6.406],
                        [0.924, 6.312],
                        [6.209, 5.864],
                        [6.169, 3.712],
                        [6.152, 2.954],
                        [6.09, 2.208],
                        [6.115, 0.971],
                        [6.005, -1.244],
                        [5.946, -2.919],
                        [5.268, -5.846]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 59",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "mm",
                  "mm": 1,
                  "nm": "Mesclar caminhos 1",
                  "mn": "ADBE Vector Filter - Merge",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.78431372549, 1, 0.470588235294, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Preenchimento 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [6.569, 6.818], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transformar"
                }
              ],
              "nm": "Grupo 1",
              "np": 61,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tm",
              "s": { "a": 0, "k": 0, "ix": 1 },
              "e": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.667], "y": [1] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "t": 17,
                    "s": [0]
                  },
                  { "t": 24, "s": [100] }
                ],
                "ix": 2
              },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "m": 1,
              "ix": 2,
              "nm": "Aparar caminhos 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 302.4,
          "st": 0,
          "ct": 1,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "Camada 3 contornos",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [228.03, 374.147, 0], "ix": 2, "l": 2 },
            "a": { "a": 0, "k": [8.648, 10.435, 0], "ix": 1, "l": 2 },
            "s": { "a": 0, "k": [248, 248, 100], "ix": 6, "l": 2 }
          },
          "ao": 0,
          "ef": [
            {
              "ty": 5,
              "nm": "Brilho",
              "np": 16,
              "mn": "ADBE Glo2",
              "ix": 1,
              "en": 1,
              "ef": [
                {
                  "ty": 7,
                  "nm": "Brilho baseado em",
                  "mn": "ADBE Glo2-0001",
                  "ix": 1,
                  "v": { "a": 0, "k": 1, "ix": 1 }
                },
                {
                  "ty": 0,
                  "nm": "Limite de brilho",
                  "mn": "ADBE Glo2-0002",
                  "ix": 2,
                  "v": { "a": 0, "k": 81, "ix": 2 }
                },
                {
                  "ty": 0,
                  "nm": "Raio do brilho",
                  "mn": "ADBE Glo2-0003",
                  "ix": 3,
                  "v": { "a": 0, "k": 0, "ix": 3 }
                },
                {
                  "ty": 0,
                  "nm": "Intensidade do brilho",
                  "mn": "ADBE Glo2-0004",
                  "ix": 4,
                  "v": { "a": 0, "k": 1.49, "ix": 4 }
                },
                {
                  "ty": 7,
                  "nm": "Composto original",
                  "mn": "ADBE Glo2-0005",
                  "ix": 5,
                  "v": { "a": 0, "k": 1, "ix": 5 }
                },
                {
                  "ty": 7,
                  "nm": "Operação de brilho",
                  "mn": "ADBE Glo2-0006",
                  "ix": 6,
                  "v": { "a": 0, "k": 3, "ix": 6 }
                },
                {
                  "ty": 7,
                  "nm": "Cores de brilho",
                  "mn": "ADBE Glo2-0007",
                  "ix": 7,
                  "v": { "a": 0, "k": 2, "ix": 7 }
                },
                {
                  "ty": 7,
                  "nm": "Repetição de cores",
                  "mn": "ADBE Glo2-0008",
                  "ix": 8,
                  "v": { "a": 0, "k": 4, "ix": 8 }
                },
                {
                  "ty": 0,
                  "nm": "Loops de cores",
                  "mn": "ADBE Glo2-0009",
                  "ix": 9,
                  "v": { "a": 0, "k": 1.52, "ix": 9 }
                },
                {
                  "ty": 0,
                  "nm": "Fase da cor",
                  "mn": "ADBE Glo2-0010",
                  "ix": 10,
                  "v": { "a": 0, "k": 0, "ix": 10 }
                },
                {
                  "ty": 0,
                  "nm": "Ponto médio A e B",
                  "mn": "ADBE Glo2-0011",
                  "ix": 11,
                  "v": { "a": 0, "k": 0.501, "ix": 11 }
                },
                {
                  "ty": 2,
                  "nm": "Cor A",
                  "mn": "ADBE Glo2-0012",
                  "ix": 12,
                  "v": { "a": 0, "k": [1, 1, 1, 0], "ix": 12 }
                },
                {
                  "ty": 2,
                  "nm": "Cor B",
                  "mn": "ADBE Glo2-0013",
                  "ix": 13,
                  "v": { "a": 0, "k": [0, 0, 0, 0], "ix": 13 }
                },
                {
                  "ty": 7,
                  "nm": "Dimensões do brilho",
                  "mn": "ADBE Glo2-0014",
                  "ix": 14,
                  "v": { "a": 0, "k": 1, "ix": 14 }
                }
              ]
            }
          ],
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0.072, 0.291],
                        [0.004, 0.07],
                        [0, 0],
                        [-0.003, -0.048],
                        [-0.336, -2.485],
                        [-0.509, 0.012],
                        [-0.587, 0.006],
                        [0, 0],
                        [0, 0],
                        [-0.507, 0.002],
                        [-0.013, 0.281]
                      ],
                      "o": [
                        [0, 0],
                        [-0.029, -0.292],
                        [-0.006, -0.025],
                        [0, 0],
                        [0.014, 0.143],
                        [0.017, 0.246],
                        [0.068, 0.504],
                        [0.49, -0.012],
                        [0, 0],
                        [0, 0],
                        [0.491, -0.019],
                        [0.282, -0.001],
                        [0.045, -0.948]
                      ],
                      "v": [
                        [3.6, 1.899],
                        [3.553, 1.42],
                        [2.881, -5.119],
                        [2.868, -5.435],
                        [-3.648, -5.337],
                        [-3.617, -4.955],
                        [-2.724, 4.561],
                        [-1.709, 5.423],
                        [-0.194, 5.405],
                        [0.619, 5.397],
                        [1.545, 5.362],
                        [3.076, 5.308],
                        [3.603, 4.818]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [0.78431372549, 1, 0.470588235294, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 2, "ix": 5 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 10,
                  "bm": 0,
                  "nm": "Traçado 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [8.648, 10.435], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transformar"
                }
              ],
              "nm": "Grupo 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tm",
              "s": { "a": 0, "k": 0, "ix": 1 },
              "e": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.667], "y": [1] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "t": 10,
                    "s": [0]
                  },
                  { "t": 17, "s": [100] }
                ],
                "ix": 2
              },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "m": 1,
              "ix": 2,
              "nm": "Aparar caminhos 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 302.4,
          "st": 0,
          "ct": 1,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "Camada 4 contornos",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [195.113, 358.54, 0], "ix": 2, "l": 2 },
            "a": { "a": 0, "k": [22.956, 35.648, 0], "ix": 1, "l": 2 },
            "s": { "a": 0, "k": [248, 248, 100], "ix": 6, "l": 2 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-1.531, 0.167],
                        [0, 0],
                        [0.012, 0.289],
                        [0, 0],
                        [0.058, 0.69],
                        [0.151, 0.408],
                        [0, 0],
                        [0.784, 0.736],
                        [0.167, 0.124],
                        [0.46, 0.231],
                        [1.01, 0.259],
                        [0.255, 0.048],
                        [0, 0],
                        [0.628, 0],
                        [0.312, -0.044],
                        [0.267, -0.055],
                        [0.579, -0.222],
                        [0.512, -0.249],
                        [0.689, -0.457],
                        [1.104, -0.929],
                        [0, 0],
                        [0.15, -0.176],
                        [0, 0],
                        [0.477, -1.355],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.15, -1.205],
                        [0, 0],
                        [-0.264, -0.577],
                        [-0.025, -0.251],
                        [-0.402, -0.828],
                        [0, 0],
                        [-0.339, -0.678],
                        [0, 0],
                        [0, 0],
                        [-0.1, -0.277],
                        [-0.502, -1.105],
                        [0, 0],
                        [0, 0],
                        [-0.138, -0.163],
                        [-0.15, -0.302],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.05, -0.451],
                        [0.062, -0.126],
                        [0.005, -0.359],
                        [0, -0.001],
                        [-0.41, -0.829],
                        [-0.352, -0.439],
                        [0, 0],
                        [-0.214, -0.139],
                        [-1.079, -0.464],
                        [-0.012, -0.013],
                        [-0.602, -0.101],
                        [-0.265, -0.037],
                        [-0.716, 0.186],
                        [-0.306, 0.125],
                        [-0.351, 0.188],
                        [-0.777, 0.514],
                        [-0.276, 0.239],
                        [-0.228, 0.263],
                        [0, 0],
                        [-0.211, 0.763],
                        [-0.025, 0.263],
                        [0, 0],
                        [0.452, 1.28],
                        [0.213, 0.388],
                        [0, 0],
                        [0.125, 0.214],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.174, -0.462],
                        [-0.094, -0.144],
                        [-0.408, -1.003],
                        [-0.204, -0.689],
                        [0.2, -0.727],
                        [0.485, -0.529],
                        [0.179, -0.125],
                        [0.289, -0.151],
                        [1.091, 0.377],
                        [0, 0],
                        [0.589, 0.665],
                        [0.325, 0.612],
                        [0.057, 0.422],
                        [0, 0],
                        [0.778, 1.631],
                        [0, 0],
                        [0.062, 0.176],
                        [0.2, 0.452],
                        [0, 0],
                        [0.063, 0],
                        [0.364, 0.753],
                        [0, 0],
                        [0.126, 0.277],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.213, 0.452],
                        [0, 0],
                        [0.063, 0.264],
                        [0, 0],
                        [-0.101, 1.116],
                        [-0.025, 0.439],
                        [-0.113, 0.314],
                        [-0.251, 0.201],
                        [-0.113, 0.226],
                        [-0.602, 0.829],
                        [-0.05, 0.276],
                        [-0.151, 0.138],
                        [-0.288, 0.151],
                        [-0.238, 0.201],
                        [-0.326, 0.125],
                        [0, 0],
                        [-0.238, 0.05],
                        [-0.111, 0.024],
                        [0, 0],
                        [-2.59, -4.196],
                        [0, 0],
                        [-0.096, -0.176],
                        [-0.15, -0.527],
                        [-0.088, -1.305],
                        [0, 0],
                        [-0.012, -0.226]
                      ],
                      "o": [
                        [0, 0],
                        [-0.012, -0.288],
                        [0, 0],
                        [-0.028, -0.7],
                        [-0.036, -0.435],
                        [0, 0],
                        [-1.192, -2.718],
                        [-0.668, -0.627],
                        [-1.37, -1.016],
                        [-0.737, -0.371],
                        [-0.27, -0.069],
                        [0, 0],
                        [-0.502, -0.113],
                        [-0.684, 0],
                        [-0.698, 0.101],
                        [-0.768, 0.156],
                        [-0.203, 0.078],
                        [-0.848, 0.412],
                        [-1.079, 0.716],
                        [0, 0],
                        [-0.213, 0.175],
                        [0, 0],
                        [-0.954, 1.08],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.251, 1.192],
                        [0, 0],
                        [0.088, 0.703],
                        [0.1, 0.201],
                        [0.076, 0.791],
                        [0, 0],
                        [0.264, 0.539],
                        [0, 0],
                        [0, 0],
                        [0.214, 0.452],
                        [0.427, 1.104],
                        [0, 0],
                        [0, 0],
                        [0.163, 0.314],
                        [0.164, 0.201],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.213, 0.427],
                        [-0.012, 0.163],
                        [0, 0],
                        [-0.022, 1.648],
                        [0.118, 0.524],
                        [0, 0],
                        [0, 0],
                        [0.175, 0.214],
                        [0.966, 0.652],
                        [0.05, 0.013],
                        [0.59, 0.2],
                        [0.301, 0.045],
                        [0.733, 0.104],
                        [0.312, -0.081],
                        [0.364, -0.163],
                        [0.841, -0.44],
                        [0.327, -0.214],
                        [0, 0],
                        [1.059, -1.221],
                        [0.22, -0.47],
                        [0.05, -0.263],
                        [0, 0],
                        [0.126, -1.317],
                        [-0.138, -0.401],
                        [0, 0],
                        [-0.125, -0.226],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.02, 0.276],
                        [0.158, 0.422],
                        [0.273, 0.423],
                        [0.205, 0.69],
                        [0.027, 0.422],
                        [-0.352, 1.276],
                        [-0.669, 0.728],
                        [-0.251, 0.176],
                        [-1.116, 0.564],
                        [0, 0],
                        [-0.866, -0.302],
                        [-0.289, -0.277],
                        [-0.372, -0.699],
                        [0, 0],
                        [-0.175, -1.908],
                        [0, 0],
                        [-0.1, -0.188],
                        [-0.151, -0.514],
                        [0, 0],
                        [-0.025, -0.075],
                        [-0.263, -0.791],
                        [0, 0],
                        [-0.126, -0.263],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.225, -0.477],
                        [0, 0],
                        [-0.138, -0.288],
                        [0, 0],
                        [-0.276, -1.091],
                        [0.05, -0.59],
                        [0.025, -0.351],
                        [0.062, -0.226],
                        [0.263, -0.213],
                        [0.452, -0.929],
                        [0.113, -0.163],
                        [0.05, -0.276],
                        [0.226, -0.214],
                        [0.301, -0.15],
                        [0.238, -0.201],
                        [0, 0],
                        [0.264, -0.088],
                        [0.337, -0.071],
                        [3.128, -0.698],
                        [0, 0],
                        [0.301, 0.487],
                        [0.086, 0.179],
                        [0.264, 0.502],
                        [0.427, 1.418],
                        [0, 0],
                        [0, 0.075],
                        [1.531, -0.167]
                      ],
                      "v": [
                        [14.719, -13.357],
                        [14.706, -14.199],
                        [14.669, -15.001],
                        [14.656, -15.654],
                        [14.369, -17.712],
                        [14.074, -18.98],
                        [13.35, -20.936],
                        [9.951, -25.93],
                        [8.356, -27.249],
                        [5.356, -29.074],
                        [2.734, -30.059],
                        [1.945, -30.234],
                        [1.242, -30.398],
                        [-1.958, -30.648],
                        [-3.753, -30.449],
                        [-5.23, -30.193],
                        [-7.035, -29.719],
                        [-8.006, -29.268],
                        [-10.126, -28.165],
                        [-12.109, -26.758],
                        [-12.725, -26.231],
                        [-13.339, -25.63],
                        [-14.281, -24.589],
                        [-16.514, -20.887],
                        [-16.954, -19.669],
                        [-17.23, -18.803],
                        [-17.38, -18.1],
                        [-17.807, -13.62],
                        [-17.719, -12.831],
                        [-17.204, -10.007],
                        [-16.979, -9.456],
                        [-15.322, -5.59],
                        [-14.971, -4.874],
                        [-14.331, -3.432],
                        [-13.98, -2.729],
                        [-13.452, -1.613],
                        [-11.859, 1.626],
                        [-10.529, 4.374],
                        [-9.762, 6.055],
                        [-9.374, 6.82],
                        [-8.622, 8.339],
                        [-7.943, 9.732],
                        [-6.161, 13.458],
                        [-5.773, 14.286],
                        [-5.07, 15.767],
                        [-4.279, 17.737],
                        [-4.316, 18.314],
                        [-4.342, 19.066],
                        [-4.104, 21.88],
                        [-3.363, 23.961],
                        [-2.159, 26.107],
                        [-1.632, 26.758],
                        [-0.465, 27.952],
                        [2.559, 29.758],
                        [4.404, 30.311],
                        [6.273, 30.562],
                        [7.122, 30.545],
                        [9.309, 30.258],
                        [10.264, 30.008],
                        [11.406, 29.533],
                        [13.79, 28.09],
                        [14.605, 27.349],
                        [15.07, 26.846],
                        [16.82, 24.148],
                        [17.505, 22.292],
                        [17.693, 21.551],
                        [17.831, 20.297],
                        [17.391, 16.156],
                        [16.939, 14.926],
                        [16.462, 14.036],
                        [16.124, 13.458],
                        [15.634, 12.643],
                        [11.068, 12.868],
                        [11.079, 13.295],
                        [11.328, 14.443],
                        [11.77, 15.291],
                        [12.826, 17.376],
                        [13.438, 19.443],
                        [13.258, 21.227],
                        [11.684, 23.836],
                        [10.227, 25.053],
                        [9.372, 25.48],
                        [5.007, 25.768],
                        [4.141, 25.48],
                        [1.844, 23.811],
                        [0.844, 22.488],
                        [0.275, 20.724],
                        [0.188, 19.758],
                        [0.062, 15.943],
                        [-1.206, 13.295],
                        [-1.518, 12.717],
                        [-2.184, 11.375],
                        [-3.087, 9.418],
                        [-4.643, 6.319],
                        [-5.648, 4.109],
                        [-7.542, 0.157],
                        [-7.943, -0.596],
                        [-8.245, -1.249],
                        [-9.348, -3.557],
                        [-9.902, -4.749],
                        [-10.566, -6.092],
                        [-12.072, -9.229],
                        [-12.65, -10.609],
                        [-13.038, -12.229],
                        [-13.214, -15.54],
                        [-13.038, -16.833],
                        [-12.762, -17.725],
                        [-12.549, -18.464],
                        [-12.26, -19.242],
                        [-10.667, -21.865],
                        [-10.189, -22.341],
                        [-9.688, -22.818],
                        [-8.997, -23.421],
                        [-8.283, -23.999],
                        [-6.187, -25.178],
                        [-5.333, -25.479],
                        [-4.732, -25.63],
                        [-3.525, -25.895],
                        [2.07, -25.919],
                        [8.318, -20.723],
                        [8.915, -19.675],
                        [9.184, -19.143],
                        [9.686, -17.611],
                        [10.05, -14.135],
                        [10.1, -13.344],
                        [10.126, -12.855]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [0.78431372549, 1, 0.470588235294, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 2, "ix": 5 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 10,
                  "bm": 0,
                  "nm": "Traçado 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [22.956, 35.648], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transformar"
                }
              ],
              "nm": "Grupo 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.364, -0.125],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-0.829, 0.025]
                      ],
                      "v": [
                        [-0.91, 0.062],
                        [0.91, -0.025]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.78431372549, 1, 0.470588235294, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Preenchimento 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [35.183, 47.413], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transformar"
                }
              ],
              "nm": "Grupo 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tm",
              "s": { "a": 0, "k": 0, "ix": 1 },
              "e": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.667], "y": [1] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "t": 0,
                    "s": [0]
                  },
                  { "t": 10, "s": [100] }
                ],
                "ix": 2
              },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "m": 1,
              "ix": 3,
              "nm": "Aparar caminhos 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 302.4,
          "st": 0,
          "ct": 1,
          "bm": 0
        }
      ]
    },
    {
      "id": "comp_1",
      "nm": "mosquetao",
      "fr": 25,
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "Camada 2 contornos",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [57.358, 40.041, 0], "ix": 2, "l": 2 },
            "a": { "a": 0, "k": [6.569, 6.818, 0], "ix": 1, "l": 2 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.071, -0.478],
                        [0.432, 0.304],
                        [-0.041, 0.158]
                      ],
                      "o": [
                        [-0.054, 0.362],
                        [-0.099, -0.069],
                        [0.278, 0.062]
                      ],
                      "v": [
                        [2.748, -4.89],
                        [1.374, -4.637],
                        [1.331, -5.13]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.254, -0.242],
                        [0.047, 0.201],
                        [-0.167, -0.02]
                      ],
                      "o": [
                        [-0.186, -0.088],
                        [-0.038, -0.162],
                        [0.398, 0.104]
                      ],
                      "v": [
                        [2.678, -3.331],
                        [2.133, -3.699],
                        [2.482, -4.263]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.578, 0.3],
                        [-0.071, -0.054],
                        [-0.019, -0.13],
                        [0.263, -0.1],
                        [0.034, 0.195],
                        [0, 0],
                        [0.038, -0.137],
                        [-0.019, -0.158],
                        [0.149, 0.06],
                        [0.091, 0.428]
                      ],
                      "o": [
                        [0.127, -0.066],
                        [0.115, 0.088],
                        [0.034, 0.23],
                        [-0.108, 0.041],
                        [0, 0],
                        [-0.186, -0.021],
                        [-0.022, 0.075],
                        [-0.139, 0.225],
                        [-0.426, -0.172],
                        [0.707, -0.282]
                      ],
                      "v": [
                        [3.35, -3.065],
                        [3.684, -2.965],
                        [3.707, -2.589],
                        [3.604, -2.092],
                        [3.203, -2.201],
                        [3.083, -2.898],
                        [2.802, -2.551],
                        [2.898, -2.241],
                        [2.484, -2.006],
                        [2.219, -2.92]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 3",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 3,
                  "ty": "sh",
                  "ix": 4,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.317, 0.158],
                        [-0.058, -0.193],
                        [0.193, -0.065],
                        [0.087, 0.072]
                      ],
                      "o": [
                        [0.189, -0.094],
                        [0.041, 0.135],
                        [-0.115, 0.039],
                        [0.199, -0.367]
                      ],
                      "v": [
                        [3.285, -4.239],
                        [3.744, -3.941],
                        [3.572, -3.445],
                        [3.105, -3.371]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 4,
                  "ty": "sh",
                  "ix": 5,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.148, 0.111],
                        [-0.116, -0.176],
                        [-0.038, -0.212],
                        [0.575, 0.381]
                      ],
                      "o": [
                        [0.186, -0.139],
                        [0.049, 0.074],
                        [-0.61, -0.193],
                        [-0.084, -0.056]
                      ],
                      "v": [
                        [3.198, -5.132],
                        [4.497, -5.01],
                        [4.516, -4.595],
                        [3.165, -4.719]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 5",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 5,
                  "ty": "sh",
                  "ix": 6,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.268, 0.013],
                        [0.086, 0.213],
                        [-0.13, -0.008],
                        [-0.071, -0.208]
                      ],
                      "o": [
                        [-0.254, -0.013],
                        [-0.067, -0.167],
                        [0.204, 0.012],
                        [0.063, 0.182]
                      ],
                      "v": [
                        [4.401, -3.454],
                        [3.974, -3.983],
                        [4.308, -4.292],
                        [4.611, -3.967]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 6,
                  "ty": "sh",
                  "ix": 7,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.285, -0.166],
                        [0.118, 0.156],
                        [-0.097, 0.198],
                        [-0.181, -0.086]
                      ],
                      "o": [
                        [-0.129, 0.076],
                        [0.035, -0.282],
                        [0.107, -0.216],
                        [0.18, 0.087]
                      ],
                      "v": [
                        [4.489, -2.112],
                        [4.032, -2.201],
                        [4.093, -2.878],
                        [4.556, -3.059]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 7",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 7,
                  "ty": "sh",
                  "ix": 8,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.112, -0.114],
                        [0.173, 0.107],
                        [0.012, 0.294],
                        [-0.092, -0.246]
                      ],
                      "o": [
                        [-0.1, 0.1],
                        [-0.043, -0.277],
                        [0.267, 0.013],
                        [0.065, 0.175]
                      ],
                      "v": [
                        [4.643, -0.954],
                        [4.208, -0.951],
                        [4.097, -1.755],
                        [4.721, -1.406]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 8",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 8,
                  "ty": "sh",
                  "ix": 9,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.04, -0.202],
                        [0.202, 0.04],
                        [0.18, 0.105],
                        [-0.256, 0.215],
                        [-0.062, -0.102],
                        [-0.005, -0.262],
                        [-0.036, 0.256],
                        [-0.006, -0.322]
                      ],
                      "o": [
                        [-0.059, 0.303],
                        [-0.157, -0.031],
                        [-0.134, -0.212],
                        [0.213, -0.179],
                        [0.083, 0.135],
                        [0.335, -0.093],
                        [0.036, -0.257],
                        [0.003, 0.191]
                      ],
                      "v": [
                        [4.7, 0.256],
                        [3.922, 0.368],
                        [3.393, 0.495],
                        [3.293, -0.497],
                        [3.789, -0.334],
                        [3.824, 0.226],
                        [4.128, -0.393],
                        [4.829, -0.479]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 9",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 9,
                  "ty": "sh",
                  "ix": 10,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.113, -0.205],
                        [0.276, 0.065],
                        [0, 0],
                        [-0.194, 0.158],
                        [-0.069, -0.211]
                      ],
                      "o": [
                        [-0.102, 0.186],
                        [0, 0],
                        [0.03, -0.218],
                        [0.115, -0.093],
                        [0.087, 0.265]
                      ],
                      "v": [
                        [4.745, 2.72],
                        [4.147, 2.959],
                        [4.208, 2.519],
                        [4.344, 1.957],
                        [4.819, 2.017]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 10",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 10,
                  "ty": "sh",
                  "ix": 11,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.243, -0.126],
                        [0.04, 0.16],
                        [-0.219, 0.076],
                        [-0.011, -0.168]
                      ],
                      "o": [
                        [-0.19, 0.098],
                        [-0.039, -0.155],
                        [0.224, -0.078],
                        [0.01, 0.148]
                      ],
                      "v": [
                        [4.733, 4.084],
                        [4.267, 3.779],
                        [4.458, 3.266],
                        [4.823, 3.58]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 11",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 11,
                  "ty": "sh",
                  "ix": 12,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.268, -0.098],
                        [0.092, 0.14],
                        [-0.223, -0.13],
                        [-0.056, -0.191]
                      ],
                      "o": [
                        [0.021, -0.228],
                        [0.328, 0.032],
                        [0.13, 0.076],
                        [-0.301, -0.017]
                      ],
                      "v": [
                        [4.28, 5.057],
                        [4.163, 4.566],
                        [4.87, 4.516],
                        [4.999, 5.04]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 12",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 12,
                  "ty": "sh",
                  "ix": 13,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.095, 0.23],
                        [-0.108, -0.109],
                        [-0.037, -0.212],
                        [0.252, 0.07]
                      ],
                      "o": [
                        [0.148, -0.036],
                        [0.184, 0.186],
                        [-0.257, -0.008],
                        [0.096, -0.276]
                      ],
                      "v": [
                        [4.14, 0.857],
                        [4.657, 0.802],
                        [4.771, 1.506],
                        [4.118, 1.53]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 13",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 13,
                  "ty": "sh",
                  "ix": 14,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.276, -0.067],
                        [0.074, 0.05],
                        [-0.136, 0.195],
                        [-0.178, -0.091]
                      ],
                      "o": [
                        [-0.103, 0.025],
                        [-0.27, -0.186],
                        [0.139, -0.2],
                        [0.184, 0.093]
                      ],
                      "v": [
                        [3.809, 4.118],
                        [3.395, 4.175],
                        [3.378, 3.487],
                        [3.774, 3.3]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 14",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 14,
                  "ty": "sh",
                  "ix": 15,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.115, -0.098],
                        [0, 0],
                        [-0.244, -0.021],
                        [-0.202, -0.303]
                      ],
                      "o": [
                        [0, 0],
                        [-0.178, -0.1],
                        [0.898, 0.08],
                        [0.059, 0.088]
                      ],
                      "v": [
                        [3.879, 4.984],
                        [2.576, 5.102],
                        [2.654, 4.459],
                        [3.837, 4.555]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 15",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 15,
                  "ty": "sh",
                  "ix": 16,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.101, -0.276],
                        [0.201, -0.074],
                        [0.007, 0.213],
                        [-0.271, -0.033],
                        [-0.217, -0.162],
                        [0.172, -0.151],
                        [-0.028, 0.364]
                      ],
                      "o": [
                        [-0.217, -0.028],
                        [-0.062, -0.366],
                        [0.268, -0.226],
                        [0.15, 0.019],
                        [0.154, 0.114],
                        [-0.271, 0.239],
                        [-0.322, 0.055]
                      ],
                      "v": [
                        [2.136, 4.171],
                        [1.584, 4.288],
                        [1.474, 3.518],
                        [2.23, 3.484],
                        [2.835, 3.344],
                        [2.996, 4.096],
                        [2.358, 3.561]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 16",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 16,
                  "ty": "sh",
                  "ix": 17,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.457, -0.046],
                        [-0.062, 0.079],
                        [-1.41, 0.202],
                        [-0.013, -0.253]
                      ],
                      "o": [
                        [-0.179, 0.018],
                        [0.49, -0.627],
                        [0.246, -0.036],
                        [-0.453, -0.075]
                      ],
                      "v": [
                        [0.803, 5.181],
                        [0.574, 4.894],
                        [1.845, 4.466],
                        [2.119, 5.062]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 17",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 17,
                  "ty": "sh",
                  "ix": 18,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.106, 0.174],
                        [-0.178, -0.013],
                        [-0.146, -0.189],
                        [0.278, -0.107]
                      ],
                      "o": [
                        [0.032, -0.219],
                        [0.427, 0.032],
                        [-0.256, -0.097],
                        [0.022, -0.284]
                      ],
                      "v": [
                        [0.495, 3.643],
                        [0.931, 3.353],
                        [1.203, 4.216],
                        [0.513, 4.217]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 18",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 18,
                  "ty": "sh",
                  "ix": 19,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.217, 0.174],
                        [0.206, 0.245],
                        [0.25, -0.159],
                        [0.117, 0.083],
                        [-0.333, 0.086],
                        [-0.029, -0.188],
                        [-0.036, 0.087],
                        [-0.309, -0.047],
                        [-0.095, -0.294],
                        [0.003, 0.306],
                        [-0.238, -0.007],
                        [0.109, -0.268],
                        [0.206, -0.01]
                      ],
                      "o": [
                        [-0.142, -0.115],
                        [-0.219, 0.276],
                        [-0.131, 0.084],
                        [0.024, 0.017],
                        [0.126, -0.032],
                        [-0.027, 0.188],
                        [0.144, -0.342],
                        [0.026, 0.28],
                        [0.329, -0.232],
                        [0.2, -0.082],
                        [0.045, 0.301],
                        [-0.113, 0.275],
                        [-0.238, 0.012]
                      ],
                      "v": [
                        [-0.269, 2.912],
                        [-0.478, 2.376],
                        [-0.938, 3.099],
                        [-1.336, 3.06],
                        [-1.112, 2.146],
                        [-0.667, 2.149],
                        [-0.547, 2.371],
                        [0.121, 2.096],
                        [0.261, 2.953],
                        [0.491, 2.138],
                        [1.119, 1.991],
                        [1.121, 2.928],
                        [0.34, 3.027]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 19",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 19,
                  "ty": "sh",
                  "ix": 20,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.016, -0.239],
                        [0.31, -0.083],
                        [-0.059, 0.214],
                        [-0.089, 0.007],
                        [-0.185, 0.34],
                        [-0.24, -0.002],
                        [-0.023, -0.218],
                        [0.12, -0.126],
                        [0.172, 0.026],
                        [0.116, 0.079]
                      ],
                      "o": [
                        [-0.265, -0.103],
                        [-0.004, -0.286],
                        [0.039, -0.141],
                        [0.349, -0.026],
                        [0.117, -0.214],
                        [0.114, 0.001],
                        [0.022, 0.197],
                        [-0.102, 0.106],
                        [-0.06, -0.139],
                        [-0.176, 0.144]
                      ],
                      "v": [
                        [-0.479, 4.37],
                        [-1.215, 4.318],
                        [-1.251, 3.621],
                        [-0.959, 3.397],
                        [-0.464, 3.844],
                        [-0.142, 3.451],
                        [0.238, 3.557],
                        [0.17, 4.095],
                        [-0.318, 4.207],
                        [-0.462, 3.881]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 20",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 20,
                  "ty": "sh",
                  "ix": 21,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.066, -0.123],
                        [0.519, -0.106],
                        [0, 0],
                        [-0.111, -0.064]
                      ],
                      "o": [
                        [-0.202, 0.372],
                        [0, 0],
                        [0.086, -0.177],
                        [0.18, 0.103]
                      ],
                      "v": [
                        [0.217, 5.015],
                        [-1.19, 5.156],
                        [-1.269, 4.722],
                        [0.207, 4.593]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 21",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 21,
                  "ty": "sh",
                  "ix": 22,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.316, 0.089],
                        [-0.229, 0.075],
                        [-0.221, -0.009],
                        [-0.12, 0.025],
                        [-0.136, -0.029],
                        [0, 0],
                        [0.104, -0.013],
                        [0.153, 0.024]
                      ],
                      "o": [
                        [-0.334, -0.094],
                        [0.273, -0.09],
                        [0.19, 0.008],
                        [0.09, -0.019],
                        [0, 0],
                        [0.048, 0.156],
                        [-0.427, 0.055],
                        [-0.282, -0.045]
                      ],
                      "v": [
                        [-2.007, 1.819],
                        [-2.13, 0.957],
                        [-1.541, 1.275],
                        [-1.259, 0.9],
                        [-0.856, 0.903],
                        [-0.65, 1.576],
                        [-0.975, 1.765],
                        [-1.445, 1.267]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 22",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 22,
                  "ty": "sh",
                  "ix": 23,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.576, 0.236],
                        [0.498, 0.101],
                        [-0.034, 0.116],
                        [-0.341, -0.532],
                        [-0.129, 0.044],
                        [-0.435, 0.009],
                        [-0.023, -0.225]
                      ],
                      "o": [
                        [-0.408, 0.236],
                        [-0.098, -0.021],
                        [0.44, -0.347],
                        [0.212, -0.137],
                        [0.427, -0.144],
                        [0.056, 0.158],
                        [-0.554, 0.087]
                      ],
                      "v": [
                        [-3.211, 5.095],
                        [-4.641, 5.274],
                        [-4.789, 4.867],
                        [-3.318, 5.104],
                        [-2.986, 4.708],
                        [-1.69, 4.636],
                        [-1.542, 5.113]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 23",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 23,
                  "ty": "sh",
                  "ix": 24,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.181, 0.044],
                        [-0.005, -0.272],
                        [0.111, 0.039],
                        [0.008, 0.262]
                      ],
                      "o": [
                        [0.128, 0.268],
                        [-0.114, 0.019],
                        [-0.22, -0.25],
                        [0.138, -0.052]
                      ],
                      "v": [
                        [-4.455, 3.468],
                        [-4.298, 4.287],
                        [-4.665, 4.416],
                        [-4.87, 3.631]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 24",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 24,
                  "ty": "sh",
                  "ix": 25,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.276, 0.016],
                        [-0.094, -0.281],
                        [-0.322, 0.022],
                        [0.619, -0.54],
                        [-0.072, -0.559],
                        [-0.15, -0.211],
                        [0.178, 0.022],
                        [0.08, 0.172],
                        [0.385, -0.126],
                        [-0.041, 0.124],
                        [-0.082, 0.119],
                        [0.003, 0.102],
                        [0.21, 1.142],
                        [-0.04, -0.259],
                        [0.107, 0.1],
                        [0.012, 0.168]
                      ],
                      "o": [
                        [0.21, -0.012],
                        [0.232, -0.297],
                        [-0.235, 0.697],
                        [0.138, 0.691],
                        [0.024, 0.187],
                        [-0.216, 0.071],
                        [-0.151, -0.197],
                        [-0.225, -0.492],
                        [-0.092, 0.03],
                        [0.075, -0.229],
                        [0.051, -0.076],
                        [-0.006, -0.26],
                        [-0.297, 0.047],
                        [-0.105, 0.074],
                        [-0.157, -0.147],
                        [-0.021, -0.283]
                      ],
                      "v": [
                        [-4.677, 2.167],
                        [-4.33, 2.457],
                        [-3.455, 2.048],
                        [-3.646, 3.3],
                        [-2.491, 3.635],
                        [-2.446, 4.234],
                        [-2.996, 4.323],
                        [-3.109, 3.717],
                        [-3.748, 4.361],
                        [-4.056, 4.157],
                        [-3.936, 3.61],
                        [-3.674, 3.426],
                        [-4.138, 2.469],
                        [-4.359, 3.089],
                        [-4.837, 3.184],
                        [-4.916, 2.593]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 25",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 25,
                  "ty": "sh",
                  "ix": 26,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.24, -0.064],
                        [-0.267, 0.274],
                        [-0.265, -0.073],
                        [0.022, -0.203],
                        [0.11, -0.063],
                        [0.217, -0.072],
                        [0.096, -0.021],
                        [0.026, 0.198]
                      ],
                      "o": [
                        [0.396, 0.105],
                        [0.082, -0.086],
                        [0.188, 0.052],
                        [-0.013, 0.126],
                        [-0.426, 0.242],
                        [-0.099, 0.033],
                        [-0.236, 0.052],
                        [-0.022, -0.167]
                      ],
                      "v": [
                        [-4.66, 1.048],
                        [-4.183, 1.569],
                        [-3.806, 1.015],
                        [-3.523, 1.361],
                        [-3.563, 1.703],
                        [-4.264, 1.647],
                        [-4.503, 1.929],
                        [-4.946, 1.544]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 26",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 26,
                  "ty": "sh",
                  "ix": 27,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.338, 0.011],
                        [-0.211, 0.182],
                        [-0.126, -0.043],
                        [-0.084, -0.098],
                        [-0.337, -0.125],
                        [-0.04, -0.201],
                        [0.324, 0.046],
                        [0.293, -0.068],
                        [0.156, 0.035],
                        [0.52, -0.252],
                        [0.058, 0.064]
                      ],
                      "o": [
                        [0.206, -0.007],
                        [0.147, -0.126],
                        [0.183, 0.062],
                        [0.267, 0.316],
                        [0.145, 0.054],
                        [0.049, 0.243],
                        [-0.318, -0.045],
                        [-0.409, 0.095],
                        [-0.339, -0.077],
                        [-0.089, 0.043],
                        [0.044, 0.048]
                      ],
                      "v": [
                        [-4.724, -0.347],
                        [-4.089, -0.332],
                        [-3.667, -0.331],
                        [-3.52, 0.064],
                        [-2.864, -0.401],
                        [-2.592, -0.086],
                        [-2.965, 0.6],
                        [-3.789, 0.694],
                        [-4.272, -0.206],
                        [-4.668, 0.71],
                        [-4.975, 0.606]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 27",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 27,
                  "ty": "sh",
                  "ix": 28,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.233, 0.168],
                        [-0.077, -0.107],
                        [0.028, -0.136],
                        [0.048, 0.248]
                      ],
                      "o": [
                        [0.122, -0.089],
                        [0.089, 0.122],
                        [-0.229, -0.142],
                        [-0.03, -0.155]
                      ],
                      "v": [
                        [-4.922, -1.549],
                        [-4.513, -1.367],
                        [-4.461, -0.536],
                        [-5.005, -0.959]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 28",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 28,
                  "ty": "sh",
                  "ix": 29,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.176, -0.502],
                        [0.083, 0.226],
                        [0.037, 0.053],
                        [0.036, -0.002],
                        [0.015, -0.015],
                        [0.007, 0.003],
                        [0.255, 0.055],
                        [0.061, 0.072],
                        [0.012, 0.17],
                        [-0.117, 0.049],
                        [-0.133, -0.055],
                        [-0.022, 0.001],
                        [-0.263, -0.15]
                      ],
                      "o": [
                        [-0.24, -0.038],
                        [-0.039, -0.108],
                        [-0.054, -0.076],
                        [-0.013, 0.015],
                        [-0.008, -0.002],
                        [-0.113, 0.139],
                        [-0.08, -0.017],
                        [-0.002, -0.188],
                        [-0.013, -0.186],
                        [0.153, -0.065],
                        [0.018, -0.022],
                        [0.164, -0.183],
                        [0.448, 0.254]
                      ],
                      "v": [
                        [-2.598, -0.65],
                        [-3.229, -0.955],
                        [-3.238, -1.218],
                        [-3.368, -1.311],
                        [-3.406, -1.265],
                        [-3.428, -1.279],
                        [-3.848, -0.716],
                        [-4.151, -0.754],
                        [-4.176, -1.278],
                        [-3.803, -1.515],
                        [-3.428, -1.279],
                        [-3.368, -1.311],
                        [-2.871, -1.569]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 29",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 29,
                  "ty": "sh",
                  "ix": 30,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-0.186, -0.1],
                        [-0.118, 0.093],
                        [-0.125, -0.141],
                        [-0.113, -0.264],
                        [-0.037, 0.205],
                        [-0.223, -0.06],
                        [-0.23, -0.027],
                        [-0.192, -0.213],
                        [-0.005, 0.003],
                        [-0.269, 0.073],
                        [0.015, -0.066],
                        [0, 0],
                        [0.173, -0.094],
                        [0.081, 0.12],
                        [0.044, 0.04],
                        [0.037, -0.022],
                        [0.005, -0.004],
                        [0.003, 0.003],
                        [0.004, -0.007],
                        [0, 0],
                        [0.07, 0.025],
                        [0.131, 0.524],
                        [0.048, -0.225],
                        [0.089, 0.106],
                        [0.019, 0.031],
                        [0.03, -0.054],
                        [0.05, -0.062],
                        [0.135, 0.076],
                        [0.09, 0.142],
                        [0.249, -0.018],
                        [0.141, 0.089]
                      ],
                      "o": [
                        [0.106, 0.158],
                        [0.105, -0.179],
                        [0.077, -0.062],
                        [0.187, 0.211],
                        [0.371, -0.082],
                        [0.056, -0.313],
                        [0.236, 0.064],
                        [0.085, 0.224],
                        [0.004, -0.004],
                        [0.233, -0.281],
                        [0.121, -0.033],
                        [0, 0],
                        [-0.036, 0.159],
                        [-0.112, 0.061],
                        [-0.06, -0.088],
                        [-0.045, -0.041],
                        [-0.004, 0.005],
                        [-0.002, -0.002],
                        [-0.004, 0.005],
                        [0, 0],
                        [-0.057, 0.107],
                        [-0.473, -0.17],
                        [-0.353, -0.024],
                        [-0.041, 0.19],
                        [-0.05, -0.096],
                        [-0.031, -0.051],
                        [-0.037, 0.064],
                        [-0.163, 0.204],
                        [-0.167, -0.094],
                        [-0.222, -0.351],
                        [-0.373, 0.028],
                        [0, 0]
                      ],
                      "v": [
                        [-4.576, -2.898],
                        [-4.376, -2.488],
                        [-4.091, -2.9],
                        [-3.718, -2.886],
                        [-3.511, -2.126],
                        [-3.294, -2.717],
                        [-2.556, -2.861],
                        [-1.906, -2.967],
                        [-1.677, -2.263],
                        [-1.661, -2.27],
                        [-1.126, -3.003],
                        [-0.807, -2.812],
                        [-0.865, -2.556],
                        [-1.017, -1.963],
                        [-1.461, -1.988],
                        [-1.527, -2.241],
                        [-1.661, -2.27],
                        [-1.672, -2.255],
                        [-1.677, -2.263],
                        [-1.692, -2.255],
                        [-1.795, -2.062],
                        [-1.977, -1.885],
                        [-2.393, -2.702],
                        [-2.69, -2.057],
                        [-3.246, -1.858],
                        [-3.282, -2.06],
                        [-3.423, -2.105],
                        [-3.547, -1.914],
                        [-4.055, -1.952],
                        [-4.255, -2.411],
                        [-4.824, -1.855],
                        [-5.078, -2.743]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 30",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 30,
                  "ty": "sh",
                  "ix": 31,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.184, -0.032],
                        [-0.039, -0.286],
                        [0, 0],
                        [0.051, 0.273]
                      ],
                      "o": [
                        [0.082, 0.292],
                        [0, 0],
                        [-0.105, -0.275],
                        [0.154, -0.105]
                      ],
                      "v": [
                        [-4.667, -4.042],
                        [-4.487, -3.245],
                        [-4.983, -3.162],
                        [-5.175, -3.911]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 31",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 31,
                  "ty": "sh",
                  "ix": 32,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.174, 0.216],
                        [-0.17, -0.109],
                        [0.041, -0.009],
                        [0.065, 0.063]
                      ],
                      "o": [
                        [0.142, -0.175],
                        [0.234, 0.148],
                        [-0.088, 0.018],
                        [-0.256, -0.248]
                      ],
                      "v": [
                        [-4.093, -3.883],
                        [-3.73, -4.02],
                        [-3.762, -3.287],
                        [-4.073, -3.187]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 32",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 32,
                  "ty": "sh",
                  "ix": 33,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.103, -0.054],
                        [0.071, 0.077],
                        [-0.099, 0.16],
                        [-0.102, -0.057]
                      ],
                      "o": [
                        [-0.085, 0.045],
                        [-0.132, -0.142],
                        [0.122, -0.133],
                        [0.187, 0.106]
                      ],
                      "v": [
                        [-2.743, -3.287],
                        [-3.139, -3.292],
                        [-3.316, -3.987],
                        [-2.812, -4.086]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 33",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 33,
                  "ty": "sh",
                  "ix": 34,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.027, 0.101],
                        [-0.381, -0.025],
                        [-0.076, -0.203],
                        [0.188, -0.017],
                        [0.12, 0.218]
                      ],
                      "o": [
                        [0.289, -0.265],
                        [0.12, 0.008],
                        [0.056, 0.15],
                        [-0.546, 0.047],
                        [-0.042, -0.077]
                      ],
                      "v": [
                        [-4.24, -4.783],
                        [-3.186, -4.979],
                        [-2.733, -4.86],
                        [-3.038, -4.369],
                        [-4.196, -4.422]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 34",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 34,
                  "ty": "sh",
                  "ix": 35,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.283, -0.062],
                        [-0.008, 0.251],
                        [-0.059, 0.111],
                        [-0.074, -0.162],
                        [-0.001, -0.003],
                        [0.001, 0.002]
                      ],
                      "o": [
                        [-0.115, 0.026],
                        [0.008, -0.223],
                        [0.064, -0.121],
                        [0.001, 0.002],
                        [-0.001, -0.003],
                        [0.006, 0.068]
                      ],
                      "v": [
                        [-1.979, -3.325],
                        [-2.377, -3.409],
                        [-2.358, -3.882],
                        [-1.814, -4.008],
                        [-1.808, -4.004],
                        [-1.814, -4.008]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 35",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 35,
                  "ty": "sh",
                  "ix": 36,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.205, -0.276],
                        [0.119, -0.102],
                        [0.175, 0.394]
                      ],
                      "o": [
                        [0.063, 0.085],
                        [-0.174, 0.151],
                        [-0.224, -0.505]
                      ],
                      "v": [
                        [-0.95, -4.915],
                        [-0.917, -4.524],
                        [-2.403, -4.718]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 36",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 36,
                  "ty": "sh",
                  "ix": 37,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.047, 0.205],
                        [-0.126, -0.051],
                        [-0.189, -0.47],
                        [0, 0]
                      ],
                      "o": [
                        [-0.043, -0.189],
                        [0.383, 0.153],
                        [0, 0],
                        [0.116, -0.301]
                      ],
                      "v": [
                        [-1.482, -3.921],
                        [-1.109, -4.166],
                        [-0.778, -3.281],
                        [-1.489, -3.284]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 37",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 37,
                  "ty": "sh",
                  "ix": 38,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.229, -0.136],
                        [0.002, 0.165],
                        [-0.011, 0.175],
                        [-0.057, -0.212]
                      ],
                      "o": [
                        [-0.146, 0.084],
                        [-0.004, -0.189],
                        [0.239, -0.03],
                        [0.045, 0.165]
                      ],
                      "v": [
                        [-0.876, -0.74],
                        [-1.419, -1.052],
                        [-1.375, -1.677],
                        [-0.824, -1.319]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 38",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 38,
                  "ty": "sh",
                  "ix": 39,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.005, 0.232],
                        [-0.25, 0.07],
                        [-0.024, -0.234],
                        [-0.009, -0.211]
                      ],
                      "o": [
                        [0.008, -0.373],
                        [0.149, -0.041],
                        [0.022, 0.218],
                        [-0.266, -0.059]
                      ],
                      "v": [
                        [-2.383, -1.011],
                        [-2.164, -1.541],
                        [-1.715, -1.384],
                        [-1.809, -0.716]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 39",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 39,
                  "ty": "sh",
                  "ix": 40,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.237, 0.039],
                        [-0.2, 0.087],
                        [0.431, 0.12]
                      ],
                      "o": [
                        [0.142, -0.024],
                        [-0.062, 0.268],
                        [-0.334, -0.093]
                      ],
                      "v": [
                        [-3.03, 0.991],
                        [-2.577, 0.905],
                        [-2.904, 1.855]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 40",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 40,
                  "ty": "sh",
                  "ix": 41,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.197, -0.313],
                        [0.132, -0.003],
                        [0.561, 0.216],
                        [0.193, 0.371],
                        [-0.363, 0.008]
                      ],
                      "o": [
                        [-0.127, 0.08],
                        [-0.12, -0.885],
                        [-0.415, -0.159],
                        [0.381, 0.202],
                        [0.435, -0.009]
                      ],
                      "v": [
                        [-1.702, 3.007],
                        [-2.192, 3.06],
                        [-3.062, 3.179],
                        [-3.164, 2.079],
                        [-2.092, 2.092]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 41",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 41,
                  "ty": "sh",
                  "ix": 42,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.072, -0.225],
                        [0.141, 0.025],
                        [-0.134, 0.187],
                        [-0.079, 0.004],
                        [0.016, -0.112]
                      ],
                      "o": [
                        [-0.16, 0.01],
                        [-0.187, -0.215],
                        [0.08, -0.11],
                        [0.084, -0.003],
                        [-0.033, 0.228]
                      ],
                      "v": [
                        [-1.573, 4.192],
                        [-2.074, 4.3],
                        [-2.11, 3.603],
                        [-1.843, 3.415],
                        [-1.547, 3.584]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 42",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 42,
                  "ty": "sh",
                  "ix": 43,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.268, -0.172],
                        [0.042, -0.34],
                        [0.228, -0.072],
                        [0.062, 0.193],
                        [0.131, 0.247],
                        [0.072, -0.185],
                        [0.216, 0.045],
                        [0.112, 0.217],
                        [0.016, 0.195],
                        [-0.131, -0.102],
                        [-0.057, -0.098],
                        [-0.03, 0.087],
                        [-0.279, 0.234],
                        [-0.163, 0.036]
                      ],
                      "o": [
                        [0.277, 0.176],
                        [-0.02, 0.171],
                        [-0.132, 0.041],
                        [-0.062, -0.196],
                        [-0.31, 0.088],
                        [-0.115, 0.293],
                        [-0.168, -0.034],
                        [-0.112, -0.216],
                        [-0.021, -0.266],
                        [0.308, 0.24],
                        [0.038, 0.064],
                        [0.254, -0.719],
                        [0.176, -0.148],
                        [0.272, -0.059]
                      ],
                      "v": [
                        [-0.07, -0.463],
                        [0.126, 0.142],
                        [0.024, 0.551],
                        [-0.399, 0.459],
                        [-0.557, -0.193],
                        [-0.827, 0.407],
                        [-1.519, 0.458],
                        [-2.156, 0.523],
                        [-2.294, -0.207],
                        [-1.889, -0.377],
                        [-1.704, 0.288],
                        [-1.487, 0.356],
                        [-1.205, -0.372],
                        [-0.679, -0.306]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 43",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 43,
                  "ty": "sh",
                  "ix": 44,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.108, -0.126],
                        [0.13, 0.077],
                        [0.019, 0.199],
                        [-0.128, 0]
                      ],
                      "o": [
                        [-0.132, 0.156],
                        [-0.109, -0.064],
                        [-0.017, -0.176],
                        [0.378, 0]
                      ],
                      "v": [
                        [0.086, -0.883],
                        [-0.306, -0.831],
                        [-0.48, -1.2],
                        [-0.245, -1.636]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 44",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 44,
                  "ty": "sh",
                  "ix": 45,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, -0.159],
                        [0.315, -0.083],
                        [0.034, 0.132],
                        [0.011, -0.008],
                        [-0.213, -0.144]
                      ],
                      "o": [
                        [0, 0.277],
                        [-0.117, 0.031],
                        [0.015, 0.058],
                        [-0.058, 0.04],
                        [0.128, 0.087]
                      ],
                      "v": [
                        [0.221, 1.257],
                        [-0.151, 1.749],
                        [-0.45, 1.528],
                        [-0.393, 0.953],
                        [0.18, 0.91]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 45",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 45,
                  "ty": "sh",
                  "ix": 46,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0.001],
                        [-0.148, -0.089],
                        [-0.227, -0.33],
                        [-0.32, 0.154],
                        [-0.057, -0.065],
                        [0.319, -0.282],
                        [0.324, 0.009],
                        [0.024, 0.098],
                        [0, -0.001]
                      ],
                      "o": [
                        [0.016, -0.046],
                        [0.249, 0.149],
                        [0.428, 0.003],
                        [0.054, -0.025],
                        [0.28, 0.319],
                        [-0.316, -0.176],
                        [-0.278, -0.008],
                        [0, 0.001],
                        [0, -0.001]
                      ],
                      "v": [
                        [-0.642, -2.864],
                        [-0.077, -2.996],
                        [0.193, -2.241],
                        [0.585, -3.054],
                        [0.842, -2.984],
                        [0.725, -1.969],
                        [-0.227, -2],
                        [-0.642, -2.864],
                        [-0.647, -2.86]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 46",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 46,
                  "ty": "sh",
                  "ix": 47,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.055, 0.219],
                        [-0.108, -0.041],
                        [0.126, -0.211],
                        [0.156, 0.145]
                      ],
                      "o": [
                        [0.06, -0.109],
                        [0.317, 0.121],
                        [-0.082, 0.138],
                        [0.008, -0.138]
                      ],
                      "v": [
                        [-0.556, -4.006],
                        [-0.089, -4.15],
                        [-0.033, -3.483],
                        [-0.586, -3.406]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 47",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 47,
                  "ty": "sh",
                  "ix": 48,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.274, 0.399],
                        [-0.239, -0.046],
                        [0.024, -0.435],
                        [0.103, -0.025]
                      ],
                      "o": [
                        [0.094, -0.137],
                        [0.178, 0.035],
                        [-0.004, 0.074],
                        [-0.814, 0.194]
                      ],
                      "v": [
                        [-0.58, -4.988],
                        [-0.185, -5.095],
                        [1.006, -4.844],
                        [0.847, -4.543]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 48",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 48,
                  "ty": "sh",
                  "ix": 49,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.382, -0.085],
                        [-0.057, 0.053],
                        [-0.12, -0.07]
                      ],
                      "o": [
                        [-0.521, 0.118],
                        [0.16, -0.144],
                        [0.14, 0.082]
                      ],
                      "v": [
                        [1.784, -1.957],
                        [1.308, -2.966],
                        [1.702, -3.043]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 49",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 49,
                  "ty": "sh",
                  "ix": 50,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.277, -0.031],
                        [-0.156, 0.212],
                        [-0.129, -0.077],
                        [-0.174, -0.309]
                      ],
                      "o": [
                        [-0.101, -0.276],
                        [0.107, -0.146],
                        [-0.028, 0.325],
                        [-0.262, -0.003]
                      ],
                      "v": [
                        [2.458, 1.666],
                        [2.376, 0.903],
                        [2.926, 0.845],
                        [3.129, 1.688]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 50",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 50,
                  "ty": "sh",
                  "ix": 51,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.167, 0.179],
                        [-0.204, -0.071],
                        [0.014, -0.219],
                        [0.1, 0.055]
                      ],
                      "o": [
                        [0.106, -0.114],
                        [-0.12, 0.217],
                        [-0.074, 0.082],
                        [-0.231, -0.129]
                      ],
                      "v": [
                        [1.492, 0.995],
                        [2.046, 0.875],
                        [1.993, 1.542],
                        [1.532, 1.654]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 51",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 51,
                  "ty": "sh",
                  "ix": 52,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.085, 0.112],
                        [-0.091, -0.028],
                        [0.137, -0.119],
                        [0.125, 0.041]
                      ],
                      "o": [
                        [0.117, -0.153],
                        [0.293, 0.091],
                        [-0.129, 0.111],
                        [-0.156, -0.051]
                      ],
                      "v": [
                        [0.449, -1.509],
                        [0.744, -1.618],
                        [0.962, -0.929],
                        [0.575, -0.86]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 52",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 52,
                  "ty": "sh",
                  "ix": 53,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.059, -0.154],
                        [0.143, -0.029],
                        [-0.137, 0.176],
                        [-0.061, -0.121]
                      ],
                      "o": [
                        [-0.099, 0.081],
                        [-0.104, -0.22],
                        [0.13, -0.115],
                        [0.051, 0.1]
                      ],
                      "v": [
                        [1.09, 1.563],
                        [0.647, 1.672],
                        [0.521, 0.919],
                        [1.054, 1.139]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 53",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 53,
                  "ty": "sh",
                  "ix": 54,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.314, -0.049],
                        [-0.223, 0.235],
                        [-0.148, -0.075],
                        [-0.181, -0.004],
                        [0.066, -0.339],
                        [0.027, 0.247],
                        [-0.15, -0.136],
                        [0.318, -0.23],
                        [0.322, 0.374],
                        [0.399, -0.163]
                      ],
                      "o": [
                        [-0.359, 0.056],
                        [0.087, -0.092],
                        [0.22, 0.112],
                        [0.372, 0.008],
                        [0.306, -0.032],
                        [-0.024, -0.207],
                        [0.309, 0.281],
                        [-0.559, -0.518],
                        [-0.102, -0.118],
                        [0.062, 0.342]
                      ],
                      "v": [
                        [0.729, 0.606],
                        [0.613, -0.413],
                        [1.101, -0.457],
                        [1.644, -0.477],
                        [2.011, 0.315],
                        [2.299, -0.266],
                        [2.817, -0.485],
                        [2.54, 0.576],
                        [1.467, 0.447],
                        [1.083, -0.214]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 54",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 54,
                  "ty": "sh",
                  "ix": 55,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.045, 0.088],
                        [-0.084, 0.008],
                        [-0.119, -0.015],
                        [0.001, -0.133],
                        [0.21, -0.04]
                      ],
                      "o": [
                        [0.031, 0.061],
                        [0.094, -0.009],
                        [0.19, 0.022],
                        [-0.003, 0.187],
                        [-0.12, 0.024]
                      ],
                      "v": [
                        [3.228, 1.522],
                        [3.397, 0.895],
                        [3.69, 0.778],
                        [3.863, 1.22],
                        [3.552, 1.657]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 55",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 55,
                  "ty": "sh",
                  "ix": 56,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.138, -0.229],
                        [-0.058, -0.287],
                        [0.11, 0.192],
                        [0.083, 0.192],
                        [-0.006, -0.25],
                        [0.114, 0.133],
                        [0.156, -0.075],
                        [0.166, 0.007],
                        [0, 0],
                        [0.023, 0.334],
                        [-0.125, -0.018],
                        [-0.09, -0.056],
                        [-0.031, 0.111],
                        [0, 0],
                        [-0.137, 0.102],
                        [-0.184, 0.02]
                      ],
                      "o": [
                        [0.161, 0.266],
                        [-0.268, 0.031],
                        [-0.069, -0.12],
                        [-0.326, -0.058],
                        [0.004, 0.23],
                        [-0.057, -0.067],
                        [-0.145, 0.069],
                        [0, 0],
                        [0.036, -0.291],
                        [-0.011, -0.157],
                        [0.18, 0.026],
                        [0.087, 0.054],
                        [0, 0],
                        [0.052, -0.185],
                        [0.122, -0.09],
                        [0.185, -0.021]
                      ],
                      "v": [
                        [3.805, 2.024],
                        [3.873, 2.976],
                        [3.325, 2.722],
                        [3.228, 2.116],
                        [2.946, 2.727],
                        [2.386, 2.943],
                        [2.24, 2.698],
                        [1.945, 3.019],
                        [1.557, 3.004],
                        [1.429, 2.115],
                        [1.862, 2.005],
                        [2.103, 2.628],
                        [2.318, 2.572],
                        [2.369, 2.392],
                        [2.64, 1.97],
                        [3.098, 2.034]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 56",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 56,
                  "ty": "sh",
                  "ix": 57,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-0.275, -0.073],
                        [0.052, -0.155],
                        [0.183, -0.02],
                        [0.24, 0.174],
                        [0.016, 0.276],
                        [0.299, 0.089],
                        [-0.002, 0.261],
                        [-0.135, 0.072],
                        [-0.187, 0.078],
                        [-0.067, 0.016],
                        [-0.082, -0.315],
                        [0.016, 0.127]
                      ],
                      "o": [
                        [0.274, 0.026],
                        [-0.203, 0.185],
                        [-0.107, 0.317],
                        [-0.238, 0.025],
                        [-0.197, -0.143],
                        [-0.033, -0.567],
                        [-0.199, -0.06],
                        [0.002, -0.178],
                        [0.212, -0.113],
                        [0.064, -0.026],
                        [0.37, -0.086],
                        [0.073, 0.174],
                        [0, 0]
                      ],
                      "v": [
                        [3.15, -1.753],
                        [3.937, -1.654],
                        [3.787, -1.062],
                        [3.09, -1.01],
                        [2.538, -0.823],
                        [2.237, -1.363],
                        [1.568, -0.823],
                        [1.33, -1.247],
                        [1.467, -1.645],
                        [2.125, -1.5],
                        [2.306, -1.731],
                        [2.926, -1.145],
                        [3.201, -1.333]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 57",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 57,
                  "ty": "sh",
                  "ix": 58,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.417, -0.255],
                        [0.105, -0.006],
                        [0.026, 0.203],
                        [0.07, 0.007],
                        [0.069, -0.091],
                        [0.124, 0.077],
                        [0.043, 0.241],
                        [-0.137, -0.033],
                        [-0.035, -0.153]
                      ],
                      "o": [
                        [0.303, 0.185],
                        [-0.138, 0.007],
                        [-0.018, -0.14],
                        [-0.14, -0.016],
                        [-0.12, 0.157],
                        [-0.125, -0.078],
                        [-0.034, -0.193],
                        [0.199, 0.049],
                        [0.296, 0.298]
                      ],
                      "v": [
                        [1.726, -4.173],
                        [1.738, -3.391],
                        [1.342, -3.413],
                        [1.206, -3.654],
                        [1, -3.43],
                        [0.534, -3.436],
                        [0.35, -3.945],
                        [0.782, -4.166],
                        [1.032, -3.682]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 58",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 58,
                  "ty": "sh",
                  "ix": 59,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.261, 0.005],
                        [0.805, -0.051],
                        [0.075, -0.012],
                        [0.347, -0.317],
                        [0.051, -0.511],
                        [-0.015, -0.673],
                        [0, 0],
                        [0, 0],
                        [0.022, -0.283],
                        [0.219, -0.468],
                        [-0.018, -0.626],
                        [0, 0],
                        [-0.309, 0.008],
                        [0, 0],
                        [-0.089, 0.59],
                        [-0.041, 0.711],
                        [0.023, 0.277],
                        [0, 0],
                        [0, 0],
                        [0.015, 0.441],
                        [0, 0],
                        [0.829, 1.01]
                      ],
                      "o": [
                        [-0.81, -0.015],
                        [-0.111, 0.007],
                        [-0.424, 0.068],
                        [-0.362, 0.329],
                        [-0.064, 0.629],
                        [0, 0],
                        [0, 0],
                        [0.011, 0.273],
                        [-0.034, 0.456],
                        [0.2, 0.609],
                        [0, 0],
                        [0.007, 0.243],
                        [0, 0],
                        [0.664, -0.018],
                        [0.11, -0.727],
                        [0.016, -0.274],
                        [0, 0],
                        [0, 0],
                        [0.002, -0.083],
                        [0, 0],
                        [-0.038, -1.063],
                        [-0.592, -0.722]
                      ],
                      "v": [
                        [0.24, -6.316],
                        [-2.127, -6.189],
                        [-4.214, -6.137],
                        [-5.44, -5.746],
                        [-6.255, -4.376],
                        [-6.24, -1.846],
                        [-6.222, -1.036],
                        [-6.188, -0.221],
                        [-6.171, 0.588],
                        [-6.182, 1.971],
                        [-6.062, 3.817],
                        [-5.927, 6.325],
                        [-2.378, 6.406],
                        [0.924, 6.312],
                        [6.209, 5.864],
                        [6.169, 3.712],
                        [6.152, 2.954],
                        [6.09, 2.208],
                        [6.115, 0.971],
                        [6.005, -1.244],
                        [5.946, -2.919],
                        [5.268, -5.846]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 59",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "mm",
                  "mm": 1,
                  "nm": "Mesclar caminhos 1",
                  "mn": "ADBE Vector Filter - Merge",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [1, 0.235294117647, 0.674509803922, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Preenchimento 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [6.569, 6.818], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transformar"
                }
              ],
              "nm": "Grupo 1",
              "np": 61,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tm",
              "s": { "a": 0, "k": 0, "ix": 1 },
              "e": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.667], "y": [1] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "t": 36,
                    "s": [0]
                  },
                  { "t": 61.2, "s": [100] }
                ],
                "ix": 2
              },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "m": 1,
              "ix": 2,
              "nm": "Aparar caminhos 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 302.4,
          "st": 0,
          "ct": 1,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "Camada 3 contornos",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [57.78, 52.397, 0], "ix": 2, "l": 2 },
            "a": { "a": 0, "k": [8.648, 10.435, 0], "ix": 1, "l": 2 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
          },
          "ao": 0,
          "ef": [
            {
              "ty": 5,
              "nm": "Brilho",
              "np": 16,
              "mn": "ADBE Glo2",
              "ix": 1,
              "en": 1,
              "ef": [
                {
                  "ty": 7,
                  "nm": "Brilho baseado em",
                  "mn": "ADBE Glo2-0001",
                  "ix": 1,
                  "v": { "a": 0, "k": 1, "ix": 1 }
                },
                {
                  "ty": 0,
                  "nm": "Limite de brilho",
                  "mn": "ADBE Glo2-0002",
                  "ix": 2,
                  "v": { "a": 0, "k": 81, "ix": 2 }
                },
                {
                  "ty": 0,
                  "nm": "Raio do brilho",
                  "mn": "ADBE Glo2-0003",
                  "ix": 3,
                  "v": { "a": 0, "k": 0, "ix": 3 }
                },
                {
                  "ty": 0,
                  "nm": "Intensidade do brilho",
                  "mn": "ADBE Glo2-0004",
                  "ix": 4,
                  "v": { "a": 0, "k": 1.49, "ix": 4 }
                },
                {
                  "ty": 7,
                  "nm": "Composto original",
                  "mn": "ADBE Glo2-0005",
                  "ix": 5,
                  "v": { "a": 0, "k": 1, "ix": 5 }
                },
                {
                  "ty": 7,
                  "nm": "Operação de brilho",
                  "mn": "ADBE Glo2-0006",
                  "ix": 6,
                  "v": { "a": 0, "k": 3, "ix": 6 }
                },
                {
                  "ty": 7,
                  "nm": "Cores de brilho",
                  "mn": "ADBE Glo2-0007",
                  "ix": 7,
                  "v": { "a": 0, "k": 2, "ix": 7 }
                },
                {
                  "ty": 7,
                  "nm": "Repetição de cores",
                  "mn": "ADBE Glo2-0008",
                  "ix": 8,
                  "v": { "a": 0, "k": 4, "ix": 8 }
                },
                {
                  "ty": 0,
                  "nm": "Loops de cores",
                  "mn": "ADBE Glo2-0009",
                  "ix": 9,
                  "v": { "a": 0, "k": 1.52, "ix": 9 }
                },
                {
                  "ty": 0,
                  "nm": "Fase da cor",
                  "mn": "ADBE Glo2-0010",
                  "ix": 10,
                  "v": { "a": 0, "k": 0, "ix": 10 }
                },
                {
                  "ty": 0,
                  "nm": "Ponto médio A e B",
                  "mn": "ADBE Glo2-0011",
                  "ix": 11,
                  "v": { "a": 0, "k": 0.501, "ix": 11 }
                },
                {
                  "ty": 2,
                  "nm": "Cor A",
                  "mn": "ADBE Glo2-0012",
                  "ix": 12,
                  "v": { "a": 0, "k": [1, 1, 1, 0], "ix": 12 }
                },
                {
                  "ty": 2,
                  "nm": "Cor B",
                  "mn": "ADBE Glo2-0013",
                  "ix": 13,
                  "v": { "a": 0, "k": [0, 0, 0, 0], "ix": 13 }
                },
                {
                  "ty": 7,
                  "nm": "Dimensões do brilho",
                  "mn": "ADBE Glo2-0014",
                  "ix": 14,
                  "v": { "a": 0, "k": 1, "ix": 14 }
                }
              ]
            }
          ],
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0.072, 0.291],
                        [0.004, 0.07],
                        [0, 0],
                        [-0.003, -0.048],
                        [-0.336, -2.485],
                        [-0.509, 0.012],
                        [-0.587, 0.006],
                        [0, 0],
                        [0, 0],
                        [-0.507, 0.002],
                        [-0.013, 0.281]
                      ],
                      "o": [
                        [0, 0],
                        [-0.029, -0.292],
                        [-0.006, -0.025],
                        [0, 0],
                        [0.014, 0.143],
                        [0.017, 0.246],
                        [0.068, 0.504],
                        [0.49, -0.012],
                        [0, 0],
                        [0, 0],
                        [0.491, -0.019],
                        [0.282, -0.001],
                        [0.045, -0.948]
                      ],
                      "v": [
                        [3.6, 1.899],
                        [3.553, 1.42],
                        [2.881, -5.119],
                        [2.868, -5.435],
                        [-3.648, -5.337],
                        [-3.617, -4.955],
                        [-2.724, 4.561],
                        [-1.709, 5.423],
                        [-0.194, 5.405],
                        [0.619, 5.397],
                        [1.545, 5.362],
                        [3.076, 5.308],
                        [3.603, 4.818]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [1, 0.235294117647, 0.674509803922, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 2, "ix": 5 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 10,
                  "bm": 0,
                  "nm": "Traçado 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [8.648, 10.435], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transformar"
                }
              ],
              "nm": "Grupo 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tm",
              "s": { "a": 0, "k": 0, "ix": 1 },
              "e": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.667], "y": [1] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "t": 31.2,
                    "s": [0]
                  },
                  { "t": 52.8, "s": [100] }
                ],
                "ix": 2
              },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "m": 1,
              "ix": 2,
              "nm": "Aparar caminhos 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 302.4,
          "st": 0,
          "ct": 1,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "Camada 4 contornos",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [45.113, 46.54, 0], "ix": 2, "l": 2 },
            "a": { "a": 0, "k": [22.956, 35.648, 0], "ix": 1, "l": 2 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-1.531, 0.167],
                        [0, 0],
                        [0.012, 0.289],
                        [0, 0],
                        [0.058, 0.69],
                        [0.151, 0.408],
                        [0, 0],
                        [0.784, 0.736],
                        [0.167, 0.124],
                        [0.46, 0.231],
                        [1.01, 0.259],
                        [0.255, 0.048],
                        [0, 0],
                        [0.628, 0],
                        [0.312, -0.044],
                        [0.267, -0.055],
                        [0.579, -0.222],
                        [0.512, -0.249],
                        [0.689, -0.457],
                        [1.104, -0.929],
                        [0, 0],
                        [0.15, -0.176],
                        [0, 0],
                        [0.477, -1.355],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.15, -1.205],
                        [0, 0],
                        [-0.264, -0.577],
                        [-0.025, -0.251],
                        [-0.402, -0.828],
                        [0, 0],
                        [-0.339, -0.678],
                        [0, 0],
                        [0, 0],
                        [-0.1, -0.277],
                        [-0.502, -1.105],
                        [0, 0],
                        [0, 0],
                        [-0.138, -0.163],
                        [-0.15, -0.302],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.05, -0.451],
                        [0.062, -0.126],
                        [0.005, -0.359],
                        [0, -0.001],
                        [-0.41, -0.829],
                        [-0.352, -0.439],
                        [0, 0],
                        [-0.214, -0.139],
                        [-1.079, -0.464],
                        [-0.012, -0.013],
                        [-0.602, -0.101],
                        [-0.265, -0.037],
                        [-0.716, 0.186],
                        [-0.306, 0.125],
                        [-0.351, 0.188],
                        [-0.777, 0.514],
                        [-0.276, 0.239],
                        [-0.228, 0.263],
                        [0, 0],
                        [-0.211, 0.763],
                        [-0.025, 0.263],
                        [0, 0],
                        [0.452, 1.28],
                        [0.213, 0.388],
                        [0, 0],
                        [0.125, 0.214],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.174, -0.462],
                        [-0.094, -0.144],
                        [-0.408, -1.003],
                        [-0.204, -0.689],
                        [0.2, -0.727],
                        [0.485, -0.529],
                        [0.179, -0.125],
                        [0.289, -0.151],
                        [1.091, 0.377],
                        [0, 0],
                        [0.589, 0.665],
                        [0.325, 0.612],
                        [0.057, 0.422],
                        [0, 0],
                        [0.778, 1.631],
                        [0, 0],
                        [0.062, 0.176],
                        [0.2, 0.452],
                        [0, 0],
                        [0.063, 0],
                        [0.364, 0.753],
                        [0, 0],
                        [0.126, 0.277],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.213, 0.452],
                        [0, 0],
                        [0.063, 0.264],
                        [0, 0],
                        [-0.101, 1.116],
                        [-0.025, 0.439],
                        [-0.113, 0.314],
                        [-0.251, 0.201],
                        [-0.113, 0.226],
                        [-0.602, 0.829],
                        [-0.05, 0.276],
                        [-0.151, 0.138],
                        [-0.288, 0.151],
                        [-0.238, 0.201],
                        [-0.326, 0.125],
                        [0, 0],
                        [-0.238, 0.05],
                        [-0.111, 0.024],
                        [0, 0],
                        [-2.59, -4.196],
                        [0, 0],
                        [-0.096, -0.176],
                        [-0.15, -0.527],
                        [-0.088, -1.305],
                        [0, 0],
                        [-0.012, -0.226]
                      ],
                      "o": [
                        [0, 0],
                        [-0.012, -0.288],
                        [0, 0],
                        [-0.028, -0.7],
                        [-0.036, -0.435],
                        [0, 0],
                        [-1.192, -2.718],
                        [-0.668, -0.627],
                        [-1.37, -1.016],
                        [-0.737, -0.371],
                        [-0.27, -0.069],
                        [0, 0],
                        [-0.502, -0.113],
                        [-0.684, 0],
                        [-0.698, 0.101],
                        [-0.768, 0.156],
                        [-0.203, 0.078],
                        [-0.848, 0.412],
                        [-1.079, 0.716],
                        [0, 0],
                        [-0.213, 0.175],
                        [0, 0],
                        [-0.954, 1.08],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.251, 1.192],
                        [0, 0],
                        [0.088, 0.703],
                        [0.1, 0.201],
                        [0.076, 0.791],
                        [0, 0],
                        [0.264, 0.539],
                        [0, 0],
                        [0, 0],
                        [0.214, 0.452],
                        [0.427, 1.104],
                        [0, 0],
                        [0, 0],
                        [0.163, 0.314],
                        [0.164, 0.201],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.213, 0.427],
                        [-0.012, 0.163],
                        [0, 0],
                        [-0.022, 1.648],
                        [0.118, 0.524],
                        [0, 0],
                        [0, 0],
                        [0.175, 0.214],
                        [0.966, 0.652],
                        [0.05, 0.013],
                        [0.59, 0.2],
                        [0.301, 0.045],
                        [0.733, 0.104],
                        [0.312, -0.081],
                        [0.364, -0.163],
                        [0.841, -0.44],
                        [0.327, -0.214],
                        [0, 0],
                        [1.059, -1.221],
                        [0.22, -0.47],
                        [0.05, -0.263],
                        [0, 0],
                        [0.126, -1.317],
                        [-0.138, -0.401],
                        [0, 0],
                        [-0.125, -0.226],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.02, 0.276],
                        [0.158, 0.422],
                        [0.273, 0.423],
                        [0.205, 0.69],
                        [0.027, 0.422],
                        [-0.352, 1.276],
                        [-0.669, 0.728],
                        [-0.251, 0.176],
                        [-1.116, 0.564],
                        [0, 0],
                        [-0.866, -0.302],
                        [-0.289, -0.277],
                        [-0.372, -0.699],
                        [0, 0],
                        [-0.175, -1.908],
                        [0, 0],
                        [-0.1, -0.188],
                        [-0.151, -0.514],
                        [0, 0],
                        [-0.025, -0.075],
                        [-0.263, -0.791],
                        [0, 0],
                        [-0.126, -0.263],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.225, -0.477],
                        [0, 0],
                        [-0.138, -0.288],
                        [0, 0],
                        [-0.276, -1.091],
                        [0.05, -0.59],
                        [0.025, -0.351],
                        [0.062, -0.226],
                        [0.263, -0.213],
                        [0.452, -0.929],
                        [0.113, -0.163],
                        [0.05, -0.276],
                        [0.226, -0.214],
                        [0.301, -0.15],
                        [0.238, -0.201],
                        [0, 0],
                        [0.264, -0.088],
                        [0.337, -0.071],
                        [3.128, -0.698],
                        [0, 0],
                        [0.301, 0.487],
                        [0.086, 0.179],
                        [0.264, 0.502],
                        [0.427, 1.418],
                        [0, 0],
                        [0, 0.075],
                        [1.531, -0.167]
                      ],
                      "v": [
                        [14.719, -13.357],
                        [14.706, -14.199],
                        [14.669, -15.001],
                        [14.656, -15.654],
                        [14.369, -17.712],
                        [14.074, -18.98],
                        [13.35, -20.936],
                        [9.951, -25.93],
                        [8.356, -27.249],
                        [5.356, -29.074],
                        [2.734, -30.059],
                        [1.945, -30.234],
                        [1.242, -30.398],
                        [-1.958, -30.648],
                        [-3.753, -30.449],
                        [-5.23, -30.193],
                        [-7.035, -29.719],
                        [-8.006, -29.268],
                        [-10.126, -28.165],
                        [-12.109, -26.758],
                        [-12.725, -26.231],
                        [-13.339, -25.63],
                        [-14.281, -24.589],
                        [-16.514, -20.887],
                        [-16.954, -19.669],
                        [-17.23, -18.803],
                        [-17.38, -18.1],
                        [-17.807, -13.62],
                        [-17.719, -12.831],
                        [-17.204, -10.007],
                        [-16.979, -9.456],
                        [-15.322, -5.59],
                        [-14.971, -4.874],
                        [-14.331, -3.432],
                        [-13.98, -2.729],
                        [-13.452, -1.613],
                        [-11.859, 1.626],
                        [-10.529, 4.374],
                        [-9.762, 6.055],
                        [-9.374, 6.82],
                        [-8.622, 8.339],
                        [-7.943, 9.732],
                        [-6.161, 13.458],
                        [-5.773, 14.286],
                        [-5.07, 15.767],
                        [-4.279, 17.737],
                        [-4.316, 18.314],
                        [-4.342, 19.066],
                        [-4.104, 21.88],
                        [-3.363, 23.961],
                        [-2.159, 26.107],
                        [-1.632, 26.758],
                        [-0.465, 27.952],
                        [2.559, 29.758],
                        [4.404, 30.311],
                        [6.273, 30.562],
                        [7.122, 30.545],
                        [9.309, 30.258],
                        [10.264, 30.008],
                        [11.406, 29.533],
                        [13.79, 28.09],
                        [14.605, 27.349],
                        [15.07, 26.846],
                        [16.82, 24.148],
                        [17.505, 22.292],
                        [17.693, 21.551],
                        [17.831, 20.297],
                        [17.391, 16.156],
                        [16.939, 14.926],
                        [16.462, 14.036],
                        [16.124, 13.458],
                        [15.634, 12.643],
                        [11.068, 12.868],
                        [11.079, 13.295],
                        [11.328, 14.443],
                        [11.77, 15.291],
                        [12.826, 17.376],
                        [13.438, 19.443],
                        [13.258, 21.227],
                        [11.684, 23.836],
                        [10.227, 25.053],
                        [9.372, 25.48],
                        [5.007, 25.768],
                        [4.141, 25.48],
                        [1.844, 23.811],
                        [0.844, 22.488],
                        [0.275, 20.724],
                        [0.188, 19.758],
                        [0.062, 15.943],
                        [-1.206, 13.295],
                        [-1.518, 12.717],
                        [-2.184, 11.375],
                        [-3.087, 9.418],
                        [-4.643, 6.319],
                        [-5.648, 4.109],
                        [-7.542, 0.157],
                        [-7.943, -0.596],
                        [-8.245, -1.249],
                        [-9.348, -3.557],
                        [-9.902, -4.749],
                        [-10.566, -6.092],
                        [-12.072, -9.229],
                        [-12.65, -10.609],
                        [-13.038, -12.229],
                        [-13.214, -15.54],
                        [-13.038, -16.833],
                        [-12.762, -17.725],
                        [-12.549, -18.464],
                        [-12.26, -19.242],
                        [-10.667, -21.865],
                        [-10.189, -22.341],
                        [-9.688, -22.818],
                        [-8.997, -23.421],
                        [-8.283, -23.999],
                        [-6.187, -25.178],
                        [-5.333, -25.479],
                        [-4.732, -25.63],
                        [-3.525, -25.895],
                        [2.07, -25.919],
                        [8.318, -20.723],
                        [8.915, -19.675],
                        [9.184, -19.143],
                        [9.686, -17.611],
                        [10.05, -14.135],
                        [10.1, -13.344],
                        [10.126, -12.855]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [1, 0.235294117647, 0.674509803922, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 2, "ix": 5 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 10,
                  "bm": 0,
                  "nm": "Traçado 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [22.956, 35.648], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transformar"
                }
              ],
              "nm": "Grupo 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.364, -0.125],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-0.829, 0.025]
                      ],
                      "v": [
                        [-0.91, 0.062],
                        [0.91, -0.025]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Caminho 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [1, 0.235294117647, 0.674509803922, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Preenchimento 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [35.183, 47.413], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transformar"
                }
              ],
              "nm": "Grupo 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tm",
              "s": { "a": 0, "k": 0, "ix": 1 },
              "e": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.667], "y": [1] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "t": 0,
                    "s": [0]
                  },
                  { "t": 31.2, "s": [100] }
                ],
                "ix": 2
              },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "m": 1,
              "ix": 3,
              "nm": "Aparar caminhos 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 302.4,
          "st": 0,
          "ct": 1,
          "bm": 0
        }
      ]
    }
  ],
  "fonts": {
    "list": [
      {
        "fName": "DMSans-Medium",
        "fFamily": "DM Sans",
        "fStyle": "Medium",
        "ascent": 71.9985961914062
      },
      {
        "fName": "ClashDisplay-Bold",
        "fFamily": "Clash Display",
        "fStyle": "Bold",
        "ascent": 66.9998168945312
      }
    ]
  },
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "brilho 4",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [295, 360.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [-2, -192, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 16.667] },
              "t": 136,
              "s": [0, 0, 100]
            },
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 1] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
              "t": 141,
              "s": [100, 100, 100]
            },
            { "t": 151, "s": [0, 0, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "sr",
              "sy": 1,
              "d": 1,
              "pt": { "a": 0, "k": 4, "ix": 3 },
              "p": { "a": 0, "k": [0, 0], "ix": 4 },
              "r": { "a": 0, "k": 120.579, "ix": 5 },
              "ir": { "a": 0, "k": 9, "ix": 6 },
              "is": { "a": 0, "k": 0, "ix": 8 },
              "or": { "a": 0, "k": 21.6, "ix": 7 },
              "os": { "a": 0, "k": 0, "ix": 9 },
              "ix": 1,
              "nm": "Caminho Polystar 1",
              "mn": "ADBE Vector Shape - Star",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 0, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Traçado 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 0.235294132607, 0.674509803922, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Preenchimento 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [-3, -192], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transformar"
            }
          ],
          "nm": "Polystar 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 165,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "brilho 3",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [254.5, 349.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [-2, -192, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 10.833] },
              "t": 142,
              "s": [0, 0, 100]
            },
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "t": 147,
              "s": [65, 65, 100]
            },
            { "t": 151, "s": [0, 0, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "sr",
              "sy": 1,
              "d": 1,
              "pt": { "a": 0, "k": 4, "ix": 3 },
              "p": { "a": 0, "k": [0, 0], "ix": 4 },
              "r": { "a": 0, "k": 120.579, "ix": 5 },
              "ir": { "a": 0, "k": 9, "ix": 6 },
              "is": { "a": 0, "k": 0, "ix": 8 },
              "or": { "a": 0, "k": 21.6, "ix": 7 },
              "os": { "a": 0, "k": 0, "ix": 9 },
              "ix": 1,
              "nm": "Caminho Polystar 1",
              "mn": "ADBE Vector Shape - Star",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 0, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Traçado 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 0.235294132607, 0.674509803922, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Preenchimento 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [-3, -192], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transformar"
            }
          ],
          "nm": "Polystar 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 165,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "brilho 2",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [269, 279.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [-2, -192, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 16.667] },
              "t": 62,
              "s": [0, 0, 100]
            },
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 1] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
              "t": 67,
              "s": [100, 100, 100]
            },
            { "t": 77, "s": [0, 0, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "sr",
              "sy": 1,
              "d": 1,
              "pt": { "a": 0, "k": 4, "ix": 3 },
              "p": { "a": 0, "k": [0, 0], "ix": 4 },
              "r": { "a": 0, "k": 120.579, "ix": 5 },
              "ir": { "a": 0, "k": 9, "ix": 6 },
              "is": { "a": 0, "k": 0, "ix": 8 },
              "or": { "a": 0, "k": 21.6, "ix": 7 },
              "os": { "a": 0, "k": 0, "ix": 9 },
              "ix": 1,
              "nm": "Caminho Polystar 1",
              "mn": "ADBE Vector Shape - Star",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 0, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Traçado 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 0.235294132607, 0.674509803922, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Preenchimento 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [-3, -192], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transformar"
            }
          ],
          "nm": "Polystar 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 165,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "brilho 1",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [243.5, 244.5, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [-2, -192, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 10.833] },
              "t": 68,
              "s": [0, 0, 100]
            },
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "t": 73,
              "s": [65, 65, 100]
            },
            { "t": 77, "s": [0, 0, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "sr",
              "sy": 1,
              "d": 1,
              "pt": { "a": 0, "k": 4, "ix": 3 },
              "p": { "a": 0, "k": [0, 0], "ix": 4 },
              "r": { "a": 0, "k": 120.579, "ix": 5 },
              "ir": { "a": 0, "k": 9, "ix": 6 },
              "is": { "a": 0, "k": 0, "ix": 8 },
              "or": { "a": 0, "k": 21.6, "ix": 7 },
              "os": { "a": 0, "k": 0, "ix": 9 },
              "ix": 1,
              "nm": "Caminho Polystar 1",
              "mn": "ADBE Vector Shape - Star",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 0, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Traçado 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 0.235294132607, 0.674509803922, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Preenchimento 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [-3, -192], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transformar"
            }
          ],
          "nm": "Polystar 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 165,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 0,
      "nm": "mosquetão verde",
      "refId": "comp_0",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": -68, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.682, "y": 1 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 106,
              "s": [178, 485, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            { "t": 115, "s": [292, 448, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [199, 357, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, -0.172] },
              "t": 106,
              "s": [-94, 94, 100]
            },
            { "t": 115, "s": [-47, 47, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "w": 360,
      "h": 800,
      "ip": 95,
      "op": 396,
      "st": 95,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 6,
      "ty": 0,
      "nm": "mosquetao",
      "refId": "comp_1",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.167], "y": [0.167] },
              "t": 85,
              "s": [9]
            },
            { "t": 92, "s": [-111] }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.682, "y": 1 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 106,
              "s": [182, 405, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            { "t": 115, "s": [294, 410, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [47.5, 46.5, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167] },
              "t": 77,
              "s": [434, 434, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
              "t": 87,
              "s": [243.909, 243.909, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, -0.073] },
              "t": 106,
              "s": [243.909, 243.909, 100]
            },
            { "t": 115, "s": [116.909, 116.909, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "w": 95,
      "h": 93,
      "ip": 0,
      "op": 302.4,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 7,
      "ty": 5,
      "nm": "Lezz",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [48, 439, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "hasMask": true,
      "masksProperties": [
        {
          "inv": false,
          "mode": "a",
          "pt": {
            "a": 1,
            "k": [
              {
                "i": { "x": 0.667, "y": 1 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 115,
                "s": [
                  {
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [199.258, -54.004],
                      [199.258, 2.836],
                      [200.455, 0.836],
                      [200.455, -56.004]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 119.8,
                "s": [
                  {
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [-17.492, -57.004],
                      [-17.492, -0.164],
                      [197.705, 0.836],
                      [197.705, -56.004]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "t": 165,
                "s": [
                  {
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [-17.492, -57.004],
                      [-17.492, -0.164],
                      [248, 0.836],
                      [248, -56.004]
                    ],
                    "c": true
                  }
                ]
              }
            ],
            "ix": 1
          },
          "o": { "a": 0, "k": 100, "ix": 3 },
          "x": { "a": 0, "k": 0, "ix": 4 },
          "nm": "Máscara 1"
        }
      ],
      "ef": [
        {
          "ty": 5,
          "nm": "Abertura de gradiente",
          "np": 7,
          "mn": "ADBE Gradient Wipe",
          "ix": 1,
          "en": 1,
          "ef": [
            {
              "ty": 0,
              "nm": "Conclusão da transição",
              "mn": "ADBE Gradient Wipe-0001",
              "ix": 1,
              "v": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "t": 116.2,
                    "s": [0.86]
                  },
                  { "t": 119.7998046875, "s": [0.498] }
                ],
                "ix": 1
              }
            },
            {
              "ty": 0,
              "nm": "Suavidade de transição",
              "mn": "ADBE Gradient Wipe-0002",
              "ix": 2,
              "v": { "a": 0, "k": 0.86, "ix": 2 }
            },
            {
              "ty": 10,
              "nm": "Camada de gradiente",
              "mn": "ADBE Gradient Wipe-0003",
              "ix": 3,
              "v": { "a": 0, "k": 7, "ix": 3 }
            },
            {
              "ty": 7,
              "nm": "Posicionamento do gradiente",
              "mn": "ADBE Gradient Wipe-0004",
              "ix": 4,
              "v": { "a": 0, "k": 3, "ix": 4 }
            },
            {
              "ty": 7,
              "nm": "Inverter gradiente",
              "mn": "ADBE Gradient Wipe-0005",
              "ix": 5,
              "v": { "a": 0, "k": 0, "ix": 5 }
            }
          ]
        }
      ],
      "t": {
        "d": {
          "k": [
            {
              "s": {
                "s": 83,
                "f": "ClashDisplay-Bold",
                "t": "Lezz",
                "ca": 0,
                "j": 0,
                "tr": 0,
                "lh": 99.6000061035156,
                "ls": 0,
                "fc": [0.784, 1, 0.471]
              },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 95,
      "op": 165,
      "st": 95,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 8,
      "ty": 5,
      "nm": "app.",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [247, 461, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "hasMask": true,
      "masksProperties": [
        {
          "inv": false,
          "mode": "a",
          "pt": {
            "a": 1,
            "k": [
              {
                "i": { "x": 0.667, "y": 1 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 115,
                "s": [
                  {
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [-3.363, -15.516],
                      [-3.363, 5.902],
                      [-2.833, 6.402],
                      [-2.833, -15.016]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 1 },
                "o": { "x": 0.167, "y": 0 },
                "t": 119.8,
                "s": [
                  {
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [-75.863, -15.266],
                      [-75.863, 6.152],
                      [-2.833, 6.402],
                      [-2.833, -15.016]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "t": 165,
                "s": [
                  {
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [-75.776, -15.556],
                      [-75.946, 5.861],
                      [17.874, 6.858],
                      [18.044, -14.559]
                    ],
                    "c": true
                  }
                ]
              }
            ],
            "ix": 1
          },
          "o": { "a": 0, "k": 100, "ix": 3 },
          "x": { "a": 0, "k": 0, "ix": 4 },
          "nm": "Máscara 1"
        }
      ],
      "t": {
        "d": {
          "k": [
            {
              "s": {
                "s": 29.1000003814697,
                "f": "DMSans-Medium",
                "t": "app.",
                "ca": 0,
                "j": 1,
                "tr": 0,
                "lh": 34.9200019836426,
                "ls": 0,
                "fc": [1, 0.235, 0.675]
              },
              "t": 0
            }
          ]
        },
        "p": {},
        "m": { "g": 1, "a": { "a": 0, "k": [0, 0], "ix": 2 } },
        "a": []
      },
      "ip": 95,
      "op": 165,
      "st": 95,
      "ct": 1,
      "bm": 0
    }
  ],
  "markers": [],
  "props": {},
  "chars": [
    {
      "ch": "a",
      "size": 29.1000003814697,
      "style": "Medium",
      "w": 55.7,
      "data": {
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [-1.767, 0.5],
                      [-1.367, 0.867],
                      [-1, 1.2],
                      [-0.734, 1.334],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.633, 3.034],
                      [3.2, 1.667],
                      [4.733, 0],
                      [3.2, -1.366],
                      [2.033, -2.5],
                      [0.4, -3.533],
                      [0, 0],
                      [-2.134, 1.434],
                      [-3, 0],
                      [-1.7, -0.966],
                      [-0.867, -1.933],
                      [0, -2.933],
                      [0, 0],
                      [3.2, -1.266],
                      [1.733, -2.366],
                      [0, -3.333],
                      [-1.334, -2.366],
                      [-2.734, -1.4],
                      [-4.134, 0]
                    ],
                    "o": [
                      [1.766, -0.5],
                      [1.366, -0.866],
                      [1, -1.2],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -4.2],
                      [-1.634, -3.033],
                      [-3.2, -1.666],
                      [-3.6, 0],
                      [-3.2, 1.367],
                      [-2.034, 2.5],
                      [0, 0],
                      [0.533, -2.8],
                      [2.133, -1.433],
                      [2.6, 0],
                      [1.7, 0.967],
                      [0.866, 1.934],
                      [0, 0],
                      [-4.467, 0],
                      [-3.2, 1.267],
                      [-1.734, 2.367],
                      [0, 2.734],
                      [1.333, 2.367],
                      [2.733, 1.4],
                      [2.133, 0]
                    ],
                    "v": [
                      [29.35, 0.45],
                      [34.05, -1.6],
                      [37.6, -4.7],
                      [40.2, -8.5],
                      [41, 0],
                      [49.7, 0],
                      [49.7, -31.2],
                      [47.25, -42.05],
                      [40, -49.1],
                      [28.1, -51.6],
                      [17.9, -49.55],
                      [10.05, -43.75],
                      [6.4, -34.7],
                      [16.4, -34.7],
                      [20.4, -41.05],
                      [28.1, -43.2],
                      [34.55, -41.75],
                      [38.4, -37.4],
                      [39.7, -30.1],
                      [26.6, -30.1],
                      [15.1, -28.2],
                      [7.7, -22.75],
                      [5.1, -14.2],
                      [7.1, -6.55],
                      [13.2, -0.9],
                      [23.5, 1.2]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "a",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [1.466, 0.667],
                      [0.766, 1.167],
                      [0, 1.667],
                      [-0.8, 1.2],
                      [-1.767, 0.7],
                      [-2.867, 0],
                      [0, 0],
                      [0, 0],
                      [0.633, -1.9],
                      [1.233, -1.5],
                      [1.733, -0.866],
                      [2.133, 0]
                    ],
                    "o": [
                      [-1.467, -0.666],
                      [-0.767, -1.166],
                      [0, -1.6],
                      [0.8, -1.2],
                      [1.766, -0.7],
                      [0, 0],
                      [0, 0],
                      [-0.067, 2],
                      [-0.634, 1.9],
                      [-1.234, 1.5],
                      [-1.734, 0.867],
                      [-2.067, 0]
                    ],
                    "v": [
                      [20.1, -7.9],
                      [16.75, -10.65],
                      [15.6, -14.9],
                      [16.8, -19.1],
                      [20.65, -21.95],
                      [27.6, -23],
                      [39.5, -23],
                      [39.5, -22.7],
                      [38.45, -16.85],
                      [35.65, -11.75],
                      [31.2, -8.2],
                      [25.4, -6.9]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "a",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              }
            ],
            "nm": "a",
            "np": 5,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ]
      },
      "fFamily": "DM Sans"
    },
    {
      "ch": "p",
      "size": 29.1000003814697,
      "style": "Medium",
      "w": 63.5,
      "data": {
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [0, 0],
                      [0, 0],
                      [-3, -1.566],
                      [-3.934, 0],
                      [-3.634, 2.266],
                      [-2.067, 3.967],
                      [0, 5.067],
                      [2.033, 3.967],
                      [3.633, 2.334],
                      [4.8, 0],
                      [2.233, -0.866],
                      [1.6, -1.366],
                      [1.066, -1.533],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [1.733, 2.8],
                      [3, 1.566],
                      [4.8, 0],
                      [3.633, -2.266],
                      [2.066, -3.966],
                      [0, -5.066],
                      [-2.034, -3.966],
                      [-3.634, -2.333],
                      [-3, 0],
                      [-2.234, 0.867],
                      [-1.6, 1.367],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [16.8, 22],
                      [16.8, -7.7],
                      [23.9, -1.15],
                      [34.3, 1.2],
                      [46.95, -2.2],
                      [55.5, -11.55],
                      [58.6, -25.1],
                      [55.55, -38.65],
                      [47.05, -48.1],
                      [34.4, -51.6],
                      [26.55, -50.3],
                      [20.8, -46.95],
                      [16.8, -42.6],
                      [15.8, -50.4],
                      [6.8, -50.4],
                      [6.8, 22]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "p",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [2.366, 1.467],
                      [1.333, 2.667],
                      [0, 3.534],
                      [-1.334, 2.634],
                      [-2.367, 1.5],
                      [-3.134, 0],
                      [-2.367, -1.5],
                      [-1.367, -2.633],
                      [0, -3.533],
                      [1.366, -2.666],
                      [2.366, -1.466],
                      [3.066, 0]
                    ],
                    "o": [
                      [-2.367, -1.466],
                      [-1.334, -2.666],
                      [0, -3.533],
                      [1.333, -2.633],
                      [2.366, -1.5],
                      [3.066, 0],
                      [2.366, 1.5],
                      [1.366, 2.634],
                      [0, 3.534],
                      [-1.367, 2.667],
                      [-2.367, 1.467],
                      [-3.134, 0]
                    ],
                    "v": [
                      [24.45, -9.7],
                      [18.9, -15.9],
                      [16.9, -25.2],
                      [18.9, -34.45],
                      [24.45, -40.65],
                      [32.7, -42.9],
                      [40.85, -40.65],
                      [46.45, -34.45],
                      [48.5, -25.2],
                      [46.45, -15.9],
                      [40.85, -9.7],
                      [32.7, -7.5]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "p",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              }
            ],
            "nm": "p",
            "np": 5,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ]
      },
      "fFamily": "DM Sans"
    },
    {
      "ch": ".",
      "size": 29.1000003814697,
      "style": "Medium",
      "w": 21.5,
      "data": {
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [-1.2, 1.234],
                      [0, 1.734],
                      [1.2, 1.234],
                      [1.933, 0],
                      [1.233, -1.233],
                      [0, -1.8],
                      [-1.234, -1.233],
                      [-1.934, 0]
                    ],
                    "o": [
                      [1.2, -1.233],
                      [0, -1.8],
                      [-1.2, -1.233],
                      [-1.934, 0],
                      [-1.234, 1.234],
                      [0, 1.734],
                      [1.233, 1.234],
                      [1.933, 0]
                    ],
                    "v": [
                      [15.5, -1.35],
                      [17.3, -5.8],
                      [15.5, -10.35],
                      [10.8, -12.2],
                      [6.05, -10.35],
                      [4.2, -5.8],
                      [6.05, -1.35],
                      [10.8, 0.5]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": ".",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              }
            ],
            "nm": ".",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ]
      },
      "fFamily": "DM Sans"
    },
    {
      "ch": "L",
      "size": 83,
      "style": "Bold",
      "w": 62.5,
      "data": {
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [60.928, 0],
                      [60.928, -17.02],
                      [21.954, -17.02],
                      [21.954, -67.474],
                      [3.021, -67.474],
                      [3.021, 0]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "L",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              }
            ],
            "nm": "L",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ]
      },
      "fFamily": "Clash Display"
    },
    {
      "ch": "e",
      "size": 83,
      "style": "Bold",
      "w": 61.2,
      "data": {
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [-17.221, 0],
                      [0, 11.279],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [7.654, 0],
                      [0.302, 6.143],
                      [0, 0],
                      [0, 1.712],
                      [17.523, 0],
                      [0, -16.516]
                    ],
                    "o": [
                      [17.12, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 3.021],
                      [-8.057, 0],
                      [0, 0],
                      [0.201, -1.813],
                      [0, -16.315],
                      [-16.919, 0],
                      [0, 19.034]
                    ],
                    "v": [
                      [31.32, 1.007],
                      [59.216, -18.228],
                      [59.216, -19.437],
                      [40.283, -19.437],
                      [40.283, -18.329],
                      [30.615, -13.998],
                      [19.537, -21.854],
                      [59.317, -21.854],
                      [59.619, -26.688],
                      [30.917, -51.764],
                      [2.014, -25.378]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "e",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              },
              {
                "ind": 1,
                "ty": "sh",
                "ix": 2,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [-6.949, 0],
                      [-0.705, -4.33],
                      [0, 0]
                    ],
                    "o": [
                      [7.05, 0],
                      [0, 0],
                      [0.806, -4.33]
                    ],
                    "v": [
                      [30.515, -37.262],
                      [41.29, -31.421],
                      [19.839, -31.421]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "e",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              }
            ],
            "nm": "e",
            "np": 5,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ]
      },
      "fFamily": "Clash Display"
    },
    {
      "ch": "z",
      "size": 83,
      "style": "Bold",
      "w": 57.8,
      "data": {
        "shapes": [
          {
            "ty": "gr",
            "it": [
              {
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [56.699, 0],
                      [56.699, -16.516],
                      [35.248, -16.516],
                      [25.378, -15.509],
                      [25.378, -16.818],
                      [35.248, -21.854],
                      [55.188, -34.644],
                      [55.188, -50.757],
                      [3.021, -50.757],
                      [3.021, -34.241],
                      [19.839, -34.241],
                      [30.414, -35.046],
                      [30.414, -33.737],
                      [19.839, -28.4],
                      [1.511, -16.113],
                      [1.511, 0]
                    ],
                    "c": true
                  },
                  "ix": 2
                },
                "nm": "z",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
              }
            ],
            "nm": "z",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
          }
        ]
      },
      "fFamily": "Clash Display"
    }
  ]
}
